import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useParams } from "react-router-dom";
import { messagesForEvacuation } from '../../helpers/messages';
import { getDatabase, ref, onValue } from "firebase/database";
import { generatePodcastScript, geocodeAddress, getPathTimes, getTravelExperienceEnglishSummary } from '../../helpers/AI_functions';
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import { getFirestore, collection, getDocs, doc, setDoc, getDoc, writeBatch, serverTimestamp } from "firebase/firestore";
import { GoogleMap, LoadScript, Marker, Polygon } from '@react-google-maps/api';
import { haversineDistance, dijkstra, reconstructPath, formatTime, buildFreeFlowConnectorRoutes } from '../../helpers/generalHelpers';
import { getTravelExperienceToDestinations, getTravelExperiencesSimple, buildTravelNarrative, getTravelExperiencesV2, selectTwoDiverseRoutes, buildTravelNarrativeV2, buildTravelNarrativeV4, getRouteTables, getRouteTablesFromRows, getTravelRouteRows, selectTwoDiverseRoutesSimple } from '../../helpers/route_functions';
import { dedupeRouteNames, buildRouteDetailsPromptLines } from '../../helpers/podcastRouteHelpers';
import HospitalIcon from "../../assets/images/hospital.png";
import SafetyIcon from '../../assets/images/safety_icon.png';
import LocationIcon from '../../assets/images/user-location.png';
import FireImage from '../../assets/images/fire_img.png'
import ParkingIconGreen from '../../assets/images/parking_icon_green.svg';
import BalloonsOverlay from '../FunScreens/BalloonsOverlay';
import { listAll } from "firebase/storage";
import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import {
    getFAQItems,
    getResourceSegments,
    routesAudioTimings,
    routesAudioTimings_ES,
    routesAudioTimings_old_ES,
    routesAudioTimings_old2,
    routeChecklistItems
  } from '../../helpers/podcastHelpers';
  
import { darkMapStyle, HOSPITAL_LOCATION, LANGUAGES } from '../../helpers/mapHelpers';
import SearchBar from '../../components/SearchBar';
import TravelNarrativeRouteTablesPanel from "./components/TravelNarrativeRouteTablesPanel";
import MasterRoutesPanel from "./components/MasterRoutesPanel";
import PostAudioTab from './components/PostAudioTab';
import AudioReviewTab from './components/AudioReviewTab';
import GeneralDetailsTab from './components/GeneralDetailsTab';
import NextStepsFaqTab from './components/NextStepsFaqTab';
import SimulationSelector from '../SectionScreens/SimulationSelector';
import "./InteractiveMapEdit.css"

// Replace with your actual API key.
const GOOGLE_MAPS_API_KEY = 'AIzaSyASU8wb6swDIo3dNxkyjfraWijCImc3-OU';

const firestore = getFirestore();

const containerStyle = {
  width: '100%',
  height: '740px'
};

const center = {lat: 37.638734, lng: -122.413164};
const DEFAULT_LOCATION = { lat: 37.721941, lng: -122.127001 };
const DEFAULT_ZOOM = { desktop: 14.5, mobile: 14.5 };

const normalizeLatLng = (loc) => {
  if (!loc || typeof loc !== "object") return null;
  const lat = Number(loc.lat ?? loc.latitude);
  const lng = Number(loc.lng ?? loc.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
};

const normalizeDefaultZoom = (value, fallback = DEFAULT_ZOOM) => {
  if (value !== "" && Number.isFinite(Number(value))) {
    const zoom = Number(value);
    return { desktop: zoom, mobile: zoom };
  }

  if (value && typeof value === "object") {
    const desktop = value.desktop === "" ? NaN : Number(value.desktop);
    const mobile = value.mobile === "" ? NaN : Number(value.mobile);
    return {
      desktop: Number.isFinite(desktop) ? desktop : fallback.desktop,
      mobile: Number.isFinite(mobile) ? mobile : fallback.mobile
    };
  }

  return { ...fallback };
};

const getViewportDefaultZoom = (zoomConfig) => {
  const normalized = normalizeDefaultZoom(zoomConfig);
  const isMob = typeof window !== "undefined" && window.innerWidth <= 768;
  return isMob ? normalized.mobile : normalized.desktop;
};

const extractXmlTagValue = (source, tag) => {
  if (!source) return "";
  const regex = new RegExp(`<${tag}>[\\s\\S]*?<\\/${tag}>`, "i");
  const match = source.match(regex);
  if (!match) return "";
  return match[0].replace(new RegExp(`<\\/?${tag}>`, "gi"), "").trim();
};

const parseMasterRoutesXmlLocal = (xml) => {
  const raw = String(xml || "");
  if (!raw.trim()) return { entries: [], map: {}, xml: "" };
  const blocks = raw.split(/<Exit option>/i).slice(1);
  const entries = [];
  blocks.forEach((chunk) => {
    const block = chunk.split(/<\/Exit option>/i)[0];
    if (!block) return;
    const id = extractXmlTagValue(block, "id");
    const title = extractXmlTagValue(block, "title");
    const key = extractXmlTagValue(block, "key");
    const routeMatch = block.match(/<Route>([\s\S]*?)<\/Route>/i);
    const routeBody = routeMatch ? routeMatch[1] : "";
    const linkBlocks = routeBody ? routeBody.split(/<Link>/i).slice(1) : [];
    const links = linkBlocks
      .map((segment) => {
        const linkContent = segment.split(/<\/Link>/i)[0] || "";
        const linkId = extractXmlTagValue(linkContent, "id");
        const linkName = extractXmlTagValue(linkContent, "name");
        if (!linkId && !linkName) return null;
        return { id: String(linkId || "").trim(), name: String(linkName || "").trim() };
      })
      .filter(Boolean);
    entries.push({
      id: String(id || "").trim(),
      title: String(title || "").trim(),
      key: String(key || "").trim(),
      links,
    });
  });
  const map = {};
  entries.forEach((entry) => {
    if (entry.id) map[String(entry.id)] = entry;
    if (entry.key) map[String(entry.key)] = entry;
  });
  return { entries, map, xml: raw };
};


// Destination nodes for shortest route search

//Default 37.638734, -122.413164
//Simulation: Testing_podcast


const ROUTE_SCENES = [];
const ROUTE_SCENES_OLD = [];


const RES_URL_KNOW = "https://protect.genasys.com/search";  // Zonehaven Aware
const RES_URL_ALERTS = "https://member.everbridge.net/453003085612570/new";        // Alameda County Alerts (San Leandro)

const InteractiveMapEdit = () => {
  // Existing states
  const [selectedWorries, setSelectedWorries] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('EN');
  const [selectedTab, setSelectedTab] = useState('routes');
  const [podcastStream, setPodcastStream] = useState("");
  const [podcastUploadPoint, setPodcastUploadPoint] = useState(null);
  const [podcastAudioUrl, setPodcastAudioUrl] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [travelExperiences, setTravelExperiences] = useState(true);
  const [isPodcastPlaying, setIsPodcastPlaying] = useState(false);
  const [travelExpNarrativeStream, setTravelExpNarrativeStream] = useState("");
  const mapRef = useRef(null);
  const podcastAudioRef = useRef(null);
  const safetyCalloutsRef = useRef([]);
  const [routesAudioUrl, setRoutesAudioUrl] = useState("");
  const routesAudioRef = useRef(null);
  const routesDataRef = useRef([]);   // ←  NEW
  const activeRouteNodeRef = useRef(null);   // remembers last highlight
  const [destinationNodes, setDestinationNodes] = useState([]);
  const firePolygonsRef = useRef([]);               // to hold the map Polygon instances
  const [firePolygons, setFirePolygons] = useState([]); // optional if you ever want to inspect them
  const [isSelectingPolygon, setIsSelectingPolygon] = useState(false);
  const [draftPolygonPoints, setDraftPolygonPoints] = useState([]);
  const [previewPolygon, setPreviewPolygon] = useState(null);
  const [isMobile, setIsMobile] = useState(false)
  const prefillDoneRef = useRef(false);
  const [mapReady, setMapReady] = useState(false);
  const wantRoutesAutoplayRef = useRef(false);
  const nearestNodeIdRef = useRef(null);
  const [nearestNodeId, setNearestNodeId] = useState(null);
  const [routeTablesDraft, setRouteTablesDraft] = useState("");
  const [editTab, setEditTab] = useState("general-details");
  const [editingNodeId, setEditingNodeId] = useState(null);
  const [additionalHouseholdNodes, setAdditionalHouseholdNodes] = useState([]);
  const [additionalNodeIdText, setAdditionalNodeIdText] = useState("");
  const [additionalNodesStatus, setAdditionalNodesStatus] = useState("");
  const [isPickingAdditionalHousehold, setIsPickingAdditionalHousehold] = useState(false);
  const additionalHouseMarkersRef = useRef([]);

  
  const { podcastId: podcastIdFromUrl } = useParams();
  const podcastId = String(podcastIdFromUrl || "").trim();


  // Map section states
  const [time, setTime] = useState(180);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [simulations, setSimulations] = useState([]);
  const [selectedSimulation, setSelectedSimulation] = useState();
  const [showPolyLines, setShowPolyLines] = useState(false);
  const [showAssumptions, setShowAssumptions] = useState(false);
  // Graph data state
  const [graphData, setGraphData] = useState({ links: [], nodes: {}, adjList: {} });
  // New state for car markers (if using Markers)
  const carMarkersRef = useRef([]);
  // We'll continue to use the existing polylineRefs.
  const polylineRefs = useRef([]);
  const circleRef = useRef(null);
  // New state to hold car overlays (if switching to OverlayView, see previous example)
  const [carOverlays, setCarOverlays] = useState([]);
  const [CalloutOverlayClass, setCalloutOverlayClass] = useState(null);

  const startPolygonSelection = useCallback(() => {
    setPreviewPolygon(null);
    setDraftPolygonPoints([]);
    setIsSelectingPolygon(true);
  }, []);

  const cancelPolygonSelection = useCallback(() => {
    setDraftPolygonPoints([]);
    setIsSelectingPolygon(false);
  }, []);

  const undoPolygonPoint = useCallback(() => {
    setDraftPolygonPoints((prev) => prev.slice(0, -1));
  }, []);

  const handlePolygonSaved = useCallback(() => {
    setDraftPolygonPoints([]);
    setIsSelectingPolygon(false);
  }, []);

  const handlePreviewPolygon = useCallback((poly) => {
    setPreviewPolygon(poly);
  }, []);

  const clearPreviewPolygon = useCallback(() => {
    setPreviewPolygon(null);
  }, []);

  const [searchText,      setSearchText]      = useState("");   // text in the bar
  const [isSearchingLoc,  setIsSearchingLoc]  = useState(false); // spinner flag

  // Storyboard overlay refs
const linkGeomsRef = useRef({});                // link_id -> WKT geometry
const storyboardLinkPolysRef = useRef(new Map()); // linkId -> google.maps.Polyline
const storyboardNodeMarkersRef = useRef(new Map()); // nodeId -> google.maps.Marker
const storyboardFirePolysRef = useRef([]); // Fire polygon ref
const lastStoryboardCameraRef = useRef(null);   // {lat,lng,zoom}
const [activeCallout, setActiveCallout] = useState(null); // { text, bg, textColor } | null
const [balloonsSpec, setBalloonsSpec] = useState(null);
const [nodeIdText, setNodeIdText] = useState("");

const isEnglish = selectedLanguage === 'EN';
const activeChecklistItems = routeChecklistItems;
const activeRoutesAudioTimings = isEnglish ? routesAudioTimings : routesAudioTimings_ES;
const resourcesI18n = isEnglish
  ? { title: "Next steps", know: "Know your zone", alerts: "AC Alerts" }
  : { title: "Siguientes pasos", know: "Conoce tu zona", alerts: "Alertas de Alameda County" };

const [resourcesAudioUrl, setResourcesAudioUrl] = useState("");
const resourcesAudioRef = useRef(null);
const [activeResourceKey, setActiveResourceKey] = useState(null);   // 'zones' | 'alerts' | null
const [resourceProgress, setResourceProgress] = useState({});       // { key: seconds }

const hospitalMarkerRef = useRef(null);
const [isSavingRoutes, setIsSavingRoutes] = useState(false);
const [isGeneratingTravelNarrative, setIsGeneratingTravelNarrative] = useState(false);
const [saveMsg, setSaveMsg] = useState("");

const [autoChecklistItems, setAutoChecklistItems] = useState([]);
const [promptAdditionCsv, setPromptAdditionCsv] = useState("");
const exitLinkNameByNodeRef = useRef({}); // nodeId -> link.name from route path
const [routeLinkSnapshots, setRouteLinkSnapshots] = useState([]);
const [masterRoutesMap, setMasterRoutesMap] = useState({});
const [masterRoutesEntries, setMasterRoutesEntries] = useState([]);
const [focusedMasterRouteNodeId, setFocusedMasterRouteNodeId] = useState(null);
const [routeEditSession, setRouteEditSession] = useState({
  isActive: false,
  nodeId: "",
  draftLinks: [],
  originalLinks: [],
});
const routeEditPreviewPolylinesRef = useRef([]);
const redrawAfterMasterSaveTimerRef = useRef(null);
const masterRoutesByNodeCacheRef = useRef(new Map());
const masterRouteDestinationIds = useMemo(() => {
  const ids = new Set();
  if (Array.isArray(masterRoutesEntries) && masterRoutesEntries.length > 0) {
    masterRoutesEntries.forEach(entry => {
      const val = String(entry?.id || entry?.key || "").trim();
      if (val) ids.add(val);
    });
  } else if (masterRoutesMap && Object.keys(masterRoutesMap).length > 0) {
    Object.values(masterRoutesMap).forEach(entry => {
      const val = String(entry?.id || entry?.key || "").trim();
      if (val) ids.add(val);
    });
  }
  return ids;
}, [masterRoutesEntries, masterRoutesMap]);
const filteredDestinationNodes = useMemo(() => {
  const dests = Array.isArray(destinationNodes) ? destinationNodes : [];
  if (!masterRouteDestinationIds || masterRouteDestinationIds.size === 0) return dests;
  return dests.filter(dest => {
    const id = String(dest?.nodeId ?? "").trim();
    return id && masterRouteDestinationIds.has(id);
  });
}, [destinationNodes, masterRouteDestinationIds]);
const linkByIdMap = useMemo(() => {
  const map = new Map();
  (graphData?.links || []).forEach((row) => {
    if (row?.link_id != null) map.set(String(row.link_id), row);
  });
  return map;
}, [graphData]);
const reverseLinkIdByLinkId = useMemo(() => {
  const reverse = new Map();
  const byStartEnd = new Map();
  (graphData?.links || []).forEach((row) => {
    const s = String(row?.start_node_id ?? "");
    const e = String(row?.end_node_id ?? "");
    const id = String(row?.link_id ?? "");
    if (!s || !e || !id) return;
    byStartEnd.set(`${s}->${e}`, id);
  });
  (graphData?.links || []).forEach((row) => {
    const s = String(row?.start_node_id ?? "");
    const e = String(row?.end_node_id ?? "");
    const id = String(row?.link_id ?? "");
    if (!s || !e || !id) return;
    const rev = byStartEnd.get(`${e}->${s}`);
    if (rev) reverse.set(id, rev);
  });
  return reverse;
}, [graphData]);

const toRouteEditDraftLink = useCallback((linkIdRaw) => {
  const linkId = String(linkIdRaw ?? "").trim();
  if (!linkId) return null;
  const row = linkByIdMap.get(linkId);
  if (!row) {
    return { id: linkId, name: "", startNodeId: "", endNodeId: "", canFlip: false, reverseId: null };
  }
  const reverseId = reverseLinkIdByLinkId.get(linkId) || null;
  return {
    id: linkId,
    name: String(row?.name || row?.street_name || "").trim(),
    startNodeId: String(row?.start_node_id ?? ""),
    endNodeId: String(row?.end_node_id ?? ""),
    canFlip: !!reverseId,
    reverseId,
  };
}, [linkByIdMap, reverseLinkIdByLinkId]);
const handleMasterRoutesChange = useCallback((payload) => {
  if (payload && payload.map) {
    setMasterRoutesMap(payload.map);
  } else {
    setMasterRoutesMap({});
  }
  if (payload && Array.isArray(payload.entries)) {
    setMasterRoutesEntries(payload.entries);
  } else {
    setMasterRoutesEntries([]);
  }
  const pid = String(podcastId || "").trim();
  const nid = String(nearestNodeIdRef.current || nearestNodeId || "").trim();
  if (pid && nid) {
    masterRoutesByNodeCacheRef.current.set(`${pid}::${nid}`, {
      entries: Array.isArray(payload?.entries) ? payload.entries : [],
      map: payload?.map || {},
      checked: true,
    });
  }
}, [podcastId, nearestNodeId]);

const ensureMasterRoutesForNode = useCallback(async (nodeId) => {
  const pid = String(podcastId || "").trim();
  const nid = String(nodeId || "").trim();
  if (!pid || !nid) return { entries: [], map: {}, checked: true };
  const cacheKey = `${pid}::${nid}`;
  if (masterRoutesByNodeCacheRef.current.has(cacheKey)) {
    return masterRoutesByNodeCacheRef.current.get(cacheKey);
  }
  try {
    const db = getFirestore();
    const masterRef = doc(db, "podcasts", pid, "podcast_details", nid, "master_routes", "current");
    const snap = await getDoc(masterRef);
    const parsed = snap.exists()
      ? parseMasterRoutesXmlLocal(String((snap.data() || {}).xml || ""))
      : { entries: [], map: {}, xml: "" };
    const resolved = { entries: parsed.entries || [], map: parsed.map || {}, checked: true };
    masterRoutesByNodeCacheRef.current.set(cacheKey, resolved);
    return resolved;
  } catch (err) {
    console.error("Failed checking master routes for node:", err);
    return { entries: [], map: {}, checked: true };
  }
}, [podcastId]);

const clearRouteEditPreview = useCallback(() => {
  routeEditPreviewPolylinesRef.current.forEach((poly) => poly.setMap(null));
  routeEditPreviewPolylinesRef.current = [];
}, []);

const renderRouteEditPreview = useCallback((draftLinks) => {
  if (!mapRef.current || !window?.google?.maps) return;
  clearRouteEditPreview();
  const gm = window.google.maps;
  (Array.isArray(draftLinks) ? draftLinks : []).forEach((link) => {
    const row = linkByIdMap.get(String(link?.id ?? ""));
    const coords = parseWktLineString(row?.geometry);
    if (!coords.length) return;
    const poly = new gm.Polyline({
      path: coords,
      geodesic: true,
      strokeColor: "#f59e0b",
      strokeOpacity: 0.95,
      strokeWeight: 6,
      zIndex: 2000,
      icons: [
        {
          icon: {
            path: gm.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 3,
            fillColor: "#f59e0b",
            fillOpacity: 1,
            strokeOpacity: 0,
          },
          offset: "90%",
        },
      ],
    });
    poly.setMap(mapRef.current);
    routeEditPreviewPolylinesRef.current.push(poly);
  });
}, [clearRouteEditPreview, linkByIdMap]);

useEffect(() => {
  if (routeEditSession?.isActive) {
    renderRouteEditPreview(routeEditSession.draftLinks);
  } else {
    clearRouteEditPreview();
  }
}, [routeEditSession, renderRouteEditPreview, clearRouteEditPreview]);

const findNearestLinkToPoint = useCallback(({ lat, lng, maxMeters = 80 }) => {
  let best = null;
  let bestD = Infinity;
  for (const row of graphData?.links || []) {
    const coords = parseWktLineString(row?.geometry);
    if (!coords.length) continue;
    for (const p of coords) {
      const d = haversineDistance(lat, lng, p.lat, p.lng);
      if (d < bestD) {
        bestD = d;
        best = row;
      }
    }
  }
  if (!best || bestD > maxMeters) return null;
  return best;
}, [graphData, haversineDistance]);

const startRouteEditForDestination = useCallback(({ nodeId }) => {
  const normalizedNodeId = String(nodeId || "").trim();
  if (!normalizedNodeId) return;
  setFocusedMasterRouteNodeId(normalizedNodeId);
  setRouteEditSession({
    isActive: true,
    nodeId: normalizedNodeId,
    draftLinks: [],
    originalLinks: [],
  });
}, []);

const cancelRouteEdit = useCallback(() => {
  setRouteEditSession({
    isActive: false,
    nodeId: "",
    draftLinks: [],
    originalLinks: [],
  });
  clearRouteEditPreview();
}, [clearRouteEditPreview]);

const removeRouteEditLink = useCallback(({ index }) => {
  setRouteEditSession((prev) => {
    if (!prev?.isActive) return prev;
    const next = (prev.draftLinks || []).filter((_, idx) => idx !== index);
    return { ...prev, draftLinks: next };
  });
}, []);

const flipRouteEditLink = useCallback(({ index }) => {
  setRouteEditSession((prev) => {
    if (!prev?.isActive) return prev;
    const current = prev?.draftLinks?.[index];
    if (!current?.canFlip || !current?.reverseId) return prev;
    const flipped = toRouteEditDraftLink(current.reverseId);
    if (!flipped) return prev;
    const next = [...(prev.draftLinks || [])];
    next[index] = flipped;
    return { ...prev, draftLinks: next };
  });
}, [toRouteEditDraftLink]);

const shortestNodePathWithLinks = useCallback((startId, endId) => {
  if (!startId || !endId) return null;
  if (String(startId) === String(endId)) return { nodePath: [String(startId)], linkIds: [] };
  const { distances, previous } = dijkstra(graphData.adjList || {}, String(startId));
  if (!Number.isFinite(distances?.[String(endId)]) || distances[String(endId)] === Infinity) return null;
  const nodePath = reconstructPath(previous, String(startId), String(endId));
  if (!Array.isArray(nodePath) || nodePath.length < 1) return null;
  const linkIds = [];
  for (let i = 0; i < nodePath.length - 1; i++) {
    const curr = String(nodePath[i]);
    const next = String(nodePath[i + 1]);
    const edge = (graphData.adjList?.[curr] || []).find((e) => String(e?.node) === next);
    if (!edge?.link?.link_id) return null;
    linkIds.push(String(edge.link.link_id));
  }
  return { nodePath, linkIds };
}, [graphData]);

const saveRouteEdit = useCallback(async ({ nodeId }) => {
  const destinationId = String(nodeId || "").trim();
  if (!destinationId) return { ok: false, links: [] };
  const startNodeId = String(nearestNodeIdRef.current || nearestNodeId || "").trim();
  if (!startNodeId) {
    window.alert("Pick a map location first so we know the start node.");
    return { ok: false, links: [] };
  }
  const draft = Array.isArray(routeEditSession?.draftLinks) ? routeEditSession.draftLinks : [];

  const finalPathLinks = [];
  let cursor = startNodeId;
  for (const link of draft) {
    const linkId = String(link?.id || "").trim();
    const start = String(link?.startNodeId || "").trim();
    const end = String(link?.endNodeId || "").trim();
    if (!linkId || !start || !end) continue;
    const pre = shortestNodePathWithLinks(cursor, start);
    if (!pre) {
      window.alert(`Could not connect route from node ${cursor} to selected link ${linkId}.`);
      return { ok: false, links: [] };
    }
    finalPathLinks.push(...pre.linkIds, linkId);
    cursor = end;
  }
  const tail = shortestNodePathWithLinks(cursor, destinationId);
  if (!tail) {
    window.alert(`Could not reach destination node ${destinationId} from selected links.`);
    return { ok: false, links: [] };
  }
  finalPathLinks.push(...tail.linkIds);

  const routeLinks = finalPathLinks.map((id) => {
    const row = linkByIdMap.get(String(id));
    return { id: String(id), name: String(row?.name || row?.street_name || "").trim() };
  });

  try {
    const pid = String(podcastId || "").trim();
    const editingNode = String(nearestNodeIdRef.current || nearestNodeId || "").trim();
    if (pid && editingNode) {
      // Fast-path save: persist selected path immediately so UI is responsive.
      await writePodcastDetailsDoc({
        pid,
        nodeId: editingNode,
        payload: {
          constrainedRoutes: {
            [destinationId]: {
              destinationId,
              pathLinks: finalPathLinks,
              totalTime: null,
              updatedAt: Date.now(),
            },
          },
        },
      });

      // Background enrichment: compute total time asynchronously and patch doc.
      if (selectedSimulation?.id && finalPathLinks.length) {
        (async () => {
          try {
            const apiRes = await getPathTimes(
              finalPathLinks,
              Number(time),
              selectedSimulation.id,
              selectedSimulation.isInteractiveMap,
              undefined
            );
            await writePodcastDetailsDoc({
              pid,
              nodeId: editingNode,
              payload: {
                constrainedRoutes: {
                  [destinationId]: {
                    destinationId,
                    pathLinks: finalPathLinks,
                    totalTime: apiRes?.total_time ?? null,
                    updatedAt: Date.now(),
                  },
                },
              },
            });
          } catch (err) {
            console.error("Background constrained-route timing failed:", err);
          }
        })();
      }
    }
  } catch (err) {
    console.error("Failed computing/saving constrained route:", err);
  }

  setRouteEditSession({
    isActive: false,
    nodeId: "",
    draftLinks: [],
    originalLinks: [],
  });
  clearRouteEditPreview();
  return { ok: true, links: routeLinks };
}, [
  routeEditSession,
  shortestNodePathWithLinks,
  linkByIdMap,
  selectedSimulation,
  time,
  podcastId,
  nearestNodeId,
  clearRouteEditPreview,
]);

const [defaultLocation, setDefaultLocation] = useState(null);
const [defaultZoom, setDefaultZoom] = useState(DEFAULT_ZOOM);
const [isSavingDefaultLocation, setIsSavingDefaultLocation] = useState(false);
const [defaultLocationStatus, setDefaultLocationStatus] = useState("");
const [defaultLocationError, setDefaultLocationError] = useState("");
const [isLoadingDefaultLocation, setIsLoadingDefaultLocation] = useState(false);
const defaultLocationAppliedRef = useRef(false);
const [mapCenter, setMapCenter] = useState(center);
const [isPickingDefaultLocation, setIsPickingDefaultLocation] = useState(false);
const [defaultLocationDraft, setDefaultLocationDraft] = useState(null);
const [defaultZoomDraft, setDefaultZoomDraft] = useState(DEFAULT_ZOOM);
const [defaultSimulationId, setDefaultSimulationId] = useState("");
const [defaultSimulationDraft, setDefaultSimulationDraft] = useState("");
const [isSavingDefaultSimulation, setIsSavingDefaultSimulation] = useState(false);
const [defaultSimulationStatus, setDefaultSimulationStatus] = useState("");
const [defaultSimulationError, setDefaultSimulationError] = useState("");
const [oneCarSimulationId, setOneCarSimulationId] = useState("");
const [oneCarSimulationDraft, setOneCarSimulationDraft] = useState("");
const [isSavingOneCarSimulation, setIsSavingOneCarSimulation] = useState(false);
const [oneCarSimulationStatus, setOneCarSimulationStatus] = useState("");
const [oneCarSimulationError, setOneCarSimulationError] = useState("");
const [imageVariables, setImageVariables] = useState({});
const initialSimulationAppliedRef = useRef(false);
const defaultLocationMarkerIcon = useMemo(() => {
  if (typeof window === "undefined" || !window.google?.maps) return null;
  return {
    path: window.google.maps.SymbolPath.CIRCLE,
    scale: 16,
    fillColor: "#ffffff",
    fillOpacity: 1,
    strokeColor: "#1d4ed8",
    strokeWeight: 4
  };
}, [mapReady]);

useEffect(() => {
  if (!podcastId) return;
  let cancelled = false;

  const loadDefaultLocation = async () => {
    try {
      setIsLoadingDefaultLocation(true);
      setDefaultLocationStatus("");
      setDefaultLocationError("");
      const snap = await getDoc(doc(firestore, "podcasts", podcastId));
      if (cancelled) return;
      const data = snap.exists() ? snap.data() : null;
      const dl = normalizeLatLng(data?.default_location);
      const dz = normalizeDefaultZoom(data?.default_zoom);
      setDefaultLocation(dl);
      setDefaultZoom(dz);
      setDefaultZoomDraft(dz);
      const simId = data?.simulation ? String(data.simulation) : "";
      setDefaultSimulationId(simId);
      setDefaultSimulationDraft(simId);
      const oneCarSimId = data?.one_car_simulation ? String(data.one_car_simulation) : "";
      setOneCarSimulationId(oneCarSimId);
      setOneCarSimulationDraft(oneCarSimId);
      setImageVariables(
        data?.image_variables && typeof data.image_variables === "object" && !Array.isArray(data.image_variables)
          ? data.image_variables
          : {}
      );
      if (!dl) {
        defaultLocationAppliedRef.current = false;
      }
    } catch (err) {
      console.error("Failed to load default location:", err);
      if (!cancelled) {
        setDefaultLocationError("Could not load default location.");
      }
    } finally {
      if (!cancelled) {
        setIsLoadingDefaultLocation(false);
      }
    }
  };

  loadDefaultLocation();
  return () => {
    cancelled = true;
  };
}, [podcastId]);

useEffect(() => {
  if (isPickingDefaultLocation) return;
  setDefaultLocationDraft(defaultLocation || null);
  setDefaultZoomDraft(defaultZoom);
}, [defaultLocation, defaultZoom, isPickingDefaultLocation]);

const activeDefaultZoom = getViewportDefaultZoom(defaultZoom);
const activeDefaultZoomDraft = getViewportDefaultZoom(defaultZoomDraft);

useEffect(() => {
  if (!defaultLocation || defaultLocationAppliedRef.current) return;
  defaultLocationAppliedRef.current = true;
  setSelectedLocation(defaultLocation);
  setMapCenter(defaultLocation);
  if (mapRef.current) {
    modifyMapCamera(mapRef.current, defaultLocation, activeDefaultZoom, 600);
  }
}, [defaultLocation, activeDefaultZoom]);

useEffect(() => {
  if (!simulations.length || initialSimulationAppliedRef.current || isLoadingDefaultLocation) return;
  let next = null;
  if (defaultSimulationId) {
    next = simulations.find((sim) => String(sim.id) === String(defaultSimulationId));
  }
  if (!next) {
    const preferred = simulations.find(
      (s) => s.name === "Testing_podcast" || s.id === "Testing_podcast"
    );
    next = preferred || simulations[simulations.length - 1];
  }
  if (next) {
    setSelectedSimulation(next);
    initialSimulationAppliedRef.current = true;
  }
}, [simulations, defaultSimulationId, isLoadingDefaultLocation]);

const handleSaveDefaultLocation = useCallback(async () => {
  if (!podcastId || !defaultLocationDraft) {
    setDefaultLocationError("Pick a location on the map first.");
    return;
  }

  try {
    setIsSavingDefaultLocation(true);
    setDefaultLocationStatus("");
    setDefaultLocationError("");

    const latLng = {
      lat: Number(defaultLocationDraft.lat),
      lng: Number(defaultLocationDraft.lng)
    };

    await setDoc(
      doc(firestore, "podcasts", podcastId),
      {
        default_location: latLng,
        default_zoom: normalizeDefaultZoom(defaultZoomDraft),
        updatedAt: serverTimestamp()
      },
      { merge: true }
    );

    setDefaultLocation(latLng);
    setDefaultZoom(normalizeDefaultZoom(defaultZoomDraft));
    setDefaultLocationStatus("Default location saved.");
    setMapCenter(latLng);
    setIsPickingDefaultLocation(false);
    if (mapRef.current) {
      modifyMapCamera(mapRef.current, latLng, getViewportDefaultZoom(defaultZoomDraft), 600);
    }
  } catch (err) {
    console.error("Could not save default location:", err);
    setDefaultLocationError("Failed to save default location.");
  } finally {
    setIsSavingDefaultLocation(false);
  }
}, [podcastId, defaultLocationDraft, defaultZoomDraft]);

const beginDefaultLocationPick = useCallback(() => {
  setDefaultLocationStatus("Editing default view — click on the map to choose a location and adjust zoom.");
  setDefaultLocationError("");
  setDefaultLocationDraft(defaultLocation || null);
  setDefaultZoomDraft(defaultZoom);
  if (mapRef.current && defaultLocation) {
    modifyMapCamera(mapRef.current, defaultLocation, getViewportDefaultZoom(defaultZoom), 600);
  }
  setIsPickingDefaultLocation(true);
}, [defaultLocation, defaultZoom]);

const cancelDefaultLocationPick = useCallback(() => {
  setIsPickingDefaultLocation(false);
  setDefaultLocationDraft(defaultLocation || null);
  setDefaultZoomDraft(defaultZoom);
  setDefaultLocationStatus("");
  setDefaultLocationError("");
  if (mapRef.current && defaultLocation) {
    modifyMapCamera(mapRef.current, defaultLocation, getViewportDefaultZoom(defaultZoom), 600);
  }
}, [defaultLocation, defaultZoom]);

const handleDefaultZoomDraftChange = useCallback((nextZoom) => {
  const normalized = normalizeDefaultZoom(nextZoom, defaultZoomDraft);
  setDefaultZoomDraft(normalized);
  if (mapRef.current) {
    const target = defaultLocationDraft || defaultLocation || mapRef.current.getCenter()?.toJSON?.();
    if (target) {
      modifyMapCamera(mapRef.current, target, getViewportDefaultZoom(normalized), 300);
    } else {
      mapRef.current.setZoom(getViewportDefaultZoom(normalized));
    }
  }
}, [defaultLocation, defaultLocationDraft, defaultZoomDraft]);

const handleDefaultSimulationSelect = useCallback(async (sim) => {
  const val = sim?.id ? String(sim.id) : "";
  setDefaultSimulationDraft(val);
  if (!podcastId || !val) {
    setDefaultSimulationError("Choose a simulation first.");
    setDefaultSimulationStatus("");
    return;
  }
  try {
    setIsSavingDefaultSimulation(true);
    setDefaultSimulationStatus("");
    setDefaultSimulationError("");
    await setDoc(
      doc(firestore, "podcasts", podcastId),
      { simulation: val, updatedAt: serverTimestamp() },
      { merge: true }
    );
    setDefaultSimulationId(val);
    setDefaultSimulationStatus("Default simulation saved.");
  } catch (err) {
    console.error("Could not save default simulation:", err);
    setDefaultSimulationError("Failed to save default simulation.");
  } finally {
    setIsSavingDefaultSimulation(false);
  }
}, [podcastId]);

const handleOneCarSimulationSelect = useCallback(async (sim) => {
  const val = sim?.id ? String(sim.id) : "";
  setOneCarSimulationDraft(val);
  if (!podcastId || !val) {
    setOneCarSimulationError("Choose a simulation first.");
    setOneCarSimulationStatus("");
    return;
  }
  try {
    setIsSavingOneCarSimulation(true);
    setOneCarSimulationStatus("");
    setOneCarSimulationError("");
    await setDoc(
      doc(firestore, "podcasts", podcastId),
      { one_car_simulation: val, updatedAt: serverTimestamp() },
      { merge: true }
    );
    setOneCarSimulationId(val);
    setOneCarSimulationStatus("One-car simulation saved.");
  } catch (err) {
    console.error("Could not save one-car simulation:", err);
    setOneCarSimulationError("Failed to save one-car simulation.");
  } finally {
    setIsSavingOneCarSimulation(false);
  }
}, [podcastId]);



const parseWktLineString = (wkt) => {
  if (!wkt) return [];
  return String(wkt)
    .replace(/^LINESTRING\s*\(/i, "")
    .replace(/\)$/, "")
    .split(",")
    .map(pt => {
      const [lng, lat] = pt.trim().split(" ").map(Number);
      return { lat, lng };
    })
    .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
};

const coerceNameToArrayOrString = (nameVal) => {
  if (Array.isArray(nameVal)) return nameVal;

  const s = (nameVal ?? "").toString().trim();
  if (!s) return "";

  // JSON array string: ["Dollar Avenue","Herman Street"]
  if (s.startsWith("[") && s.endsWith("]")) {
    // 1) Try normal JSON first
    try {
      const arr = JSON.parse(s);
      if (Array.isArray(arr)) return arr;
    } catch (_) {}

    // 2) Handle python-ish list string: ['Dollar Avenue', 'Herman Street']
    try {
      const jsonish = s.replace(/'/g, '"');
      const arr2 = JSON.parse(jsonish);
      if (Array.isArray(arr2)) return arr2;
    } catch (_) {}
  }

  return s;
};
const buildExitTitleFromLinkName = (linkNameRaw) => {
  const coerced = coerceNameToArrayOrString(linkNameRaw);

  let base = "";
  if (Array.isArray(coerced)) {
    const cleaned = coerced.map(x => String(x || "").trim()).filter(Boolean);
    base = cleaned.join(" - ");
  } else {
    base = String(coerced || "").trim();
  }

  if (!base) return "";
  return `${base} exit`;
};

const csvEscape = (value) => {
  const s = (value ?? "").toString();
  // Quote if contains comma, quote, newline
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

// Finds the "nearest" link to a destination node.
// 1) prefer links incident to the node (start/end == nodeId)
// 2) if none, fallback to globally nearest geometry vertex distance
const findNearestLinkRowForNode = ({ nodeId, graphData, haversineDistance }) => {
  const id = String(nodeId);
  const node = graphData?.nodes?.[id];
  const links = graphData?.links || [];
  if (!node || !links.length) return null;

  const incident = links.filter(r =>
    String(r.start_node_id) === id || String(r.end_node_id) === id
  );
  const candidates = incident.length ? incident : links;

  let best = null;
  let bestD = Infinity;

  for (const row of candidates) {
    const coords = parseWktLineString(row.geometry);
    if (!coords.length) continue;

    // min distance to any vertex (good enough + fast)
    for (const p of coords) {
      const d = haversineDistance(node.lat, node.lng, p.lat, p.lng);
      if (d < bestD) {
        bestD = d;
        best = row;
      }
    }
  }
  return best;
};


const buildChecklistItemsAndPromptCsv = ({
  destinationNodes,
  graphData,
  haversineDistance,
  masterRoutesMap,
  masterRoutesEntries,
  imageVariables,
}) => {
  const defaultImageNames = [
    "alert",
    "blocked_road",
    "neighbour_buddy",
    "go_bag",
    "firefighter_congestion",
    "car_abandon_accident",
    "traffic_congestion",
    "leave_early",
    "know_your_zone",
  ];
  const customImageNames = Object.keys(
    imageVariables && typeof imageVariables === "object" && !Array.isArray(imageVariables)
      ? imageVariables
      : {}
  )
    .map((name) => String(name || "").trim())
    .filter(Boolean);
  const possibleImageNames = [
    ...customImageNames,
    ...defaultImageNames.filter((name) => !customImageNames.includes(name)),
  ];
  const safeMasterRoutesEntries = Array.isArray(masterRoutesEntries) ? masterRoutesEntries : [];
  const dests = Array.isArray(destinationNodes) ? destinationNodes : [];
  const destById = new Map();
  dests.forEach(d => {
    const id = String(d?.nodeId ?? "").trim();
    if (id) destById.set(id, d);
  });
  const useMasterEntries = safeMasterRoutesEntries.length > 0;
  const hasMasterRoutes =
    useMasterEntries || !!(masterRoutesMap && Object.keys(masterRoutesMap).length);

  // Build checklist items (destinations only) + CSV rows (Intro + dests + Conclusion)
  const checklistOnly = [];

  // CSV header + Intro
  const lines = ["Name, id", "Intro, Null"];

  const targets = useMasterEntries
    ? safeMasterRoutesEntries
        .map(entry => {
          const nodeId = String(entry?.id || entry?.key || "").trim();
          if (!nodeId) return null;
          return { nodeId, masterEntry: entry, dest: destById.get(nodeId) };
        })
        .filter(Boolean)
    : dests
        .map(d => {
          const nodeId = String(d?.nodeId ?? "").trim();
          if (!nodeId) return null;
          return { nodeId, dest: d, masterEntry: masterRoutesMap?.[nodeId] };
        })
        .filter(Boolean);

  for (const target of targets) {
    const nodeId = target.nodeId;
    if (!nodeId) continue;

    const linkRow = target.dest
      ? findNearestLinkRowForNode({ nodeId, graphData, haversineDistance })
      : null;
    const routeLinkName = target.dest ? exitLinkNameByNodeRef.current?.[nodeId] : null;

    const masterEntry = target.masterEntry || masterRoutesMap?.[nodeId];
    if (useMasterEntries && !masterEntry) continue;

    const derivedTitle =
      (routeLinkName ? buildExitTitleFromLinkName(routeLinkName) : "") ||
      (linkRow?.name ? buildExitTitleFromLinkName(linkRow.name) : "") ||
      (target.dest?.name ? `${String(target.dest.name).trim()} exit` : `Node ${nodeId} exit`);

    const title = (masterEntry?.title?.trim()) || derivedTitle;
    const csvId = masterEntry?.key ? String(masterEntry.key) : nodeId;

    const item = {
      key: nodeId,
      title,
      nodeId,
      id: nodeId, // <- ensures anything reading "id" gets the node id
    };

    checklistOnly.push(item);

    // CSV row for this destination
    lines.push(`${csvEscape(title)}, ${csvEscape(csvId)}`);
  }

  // Conclusion row
  lines.push("Conclusion, Null");
  if (hasMasterRoutes) {
    lines.push("");
    const detailLines = buildRouteDetailsPromptLines(
      safeMasterRoutesEntries.length ? safeMasterRoutesEntries : masterRoutesMap,
      csvEscape
    );
    lines.push(...detailLines);
  }
  lines.push("");
  lines.push("<Possible image names>");
  possibleImageNames.forEach((name) => lines.push(name));
  lines.push("</Possible image names>");

  return {
    checklistItems: checklistOnly,
    promptAdditionCsv: lines.join("\n"),
  };
};

const applyMasterNamesToRouteTablesDraft = (draft, masterRoutesMap) => {
  const hasMasterRoutes = !!(masterRoutesMap && Object.keys(masterRoutesMap).length);
  if (!draft || typeof draft !== "string") {
    return draft;
  }
  try {
    const parsed = JSON.parse(draft);
    if (!Array.isArray(parsed)) return draft;
    let changed = false;
    const updated = parsed.map(item => {
      const id = String(item?.id ?? "");
      const entry = id && masterRoutesMap && masterRoutesMap[id];
      if (!entry) return item;
      const next = { ...item };
      if (entry?.title && next.exitName !== entry.title) {
        changed = true;
        next.exitName = entry.title;
      }
      const linkNames = dedupeRouteNames(
        (entry?.links || []).map(l => l?.name).filter(Boolean)
      );
      if (linkNames.length && JSON.stringify(next.path) !== JSON.stringify(linkNames)) {
        changed = true;
        next.path = linkNames;
      }
      return next;
    });
    const filtered = hasMasterRoutes
      ? updated.filter(item => {
          const id = String(item?.id ?? "");
          const exists = !!(id && masterRoutesMap && masterRoutesMap[id]);
          if (!exists) changed = true;
          return exists;
        })
      : updated;
    return changed ? JSON.stringify(filtered, null, 2) : draft;
  } catch {
    return draft;
  }
};

const applyMasterNamesToChecklistItems = (items, masterRoutesMap) => {
  const hasMasterRoutes = !!(masterRoutesMap && Object.keys(masterRoutesMap).length);
  if (!Array.isArray(items)) {
    return items;
  }
  let changed = false;
  const updated = items.map(item => {
    const nodeId = String(item?.nodeId ?? item?.id ?? item?.key ?? "");
    const entry = nodeId && masterRoutesMap && masterRoutesMap[nodeId];
    if (entry?.title && item?.title !== entry.title) {
      changed = true;
      return { ...item, title: entry.title };
    }
    return item;
  });
  const filtered = hasMasterRoutes
    ? updated.filter(item => {
        const nodeId = String(item?.nodeId ?? item?.id ?? item?.key ?? "");
        const exists = !!(nodeId && masterRoutesMap && masterRoutesMap[nodeId]);
        if (!exists) changed = true;
        return exists;
      })
    : updated;
  return changed ? filtered : items;
};

const parseCsvValue = (value) => {
  const trimmed = (value ?? "").trim();
  if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
    return trimmed.slice(1, -1).replace(/""/g, '"');
  }
  return trimmed;
};

const applyMasterNamesToPromptCsv = (csv, masterRoutesMap) => {
  const hasMasterRoutes = !!(masterRoutesMap && Object.keys(masterRoutesMap).length);
  if (typeof csv !== "string") {
    return csv;
  }
  const lines = csv.split(/\r?\n/);
  let changed = false;
  const updated = [];
  lines.forEach((line, idx) => {
    const commaIdx = line.indexOf(",");
    if (commaIdx === -1) {
      updated.push(line);
      return;
    }
    const left = line.slice(0, commaIdx);
    const right = line.slice(commaIdx + 1);
    const nameVal = parseCsvValue(left);
    const idVal = parseCsvValue(right);
    const normalizedId = String(idVal || "").trim();
    const isSpecialRow =
      !normalizedId ||
      /^null$/i.test(normalizedId) ||
      /^id$/i.test(normalizedId) ||
      /^intro$/i.test((nameVal || "").toLowerCase()) ||
      /^conclusion$/i.test((nameVal || "").toLowerCase()) ||
      idx === 0;
    const entry = normalizedId && masterRoutesMap ? masterRoutesMap[normalizedId] : null;
    if (hasMasterRoutes && normalizedId && !entry && !isSpecialRow) {
      changed = true;
      return;
    }
    let finalName = nameVal;
    if (entry?.title && entry.title !== nameVal) {
      finalName = entry.title;
      changed = true;
    }
    const rebuilt = `${csvEscape(finalName ?? "")}, ${csvEscape(normalizedId || idVal || "")}`;
    if (rebuilt !== line) changed = true;
    updated.push(rebuilt);
  });
  return changed ? updated.join("\n") : csv;
};

useEffect(() => {
  setRouteTablesDraft(prev => {
    const next = applyMasterNamesToRouteTablesDraft(prev, masterRoutesMap);
    return next === prev ? prev : next;
  });
  setAutoChecklistItems(prev => {
    const next = applyMasterNamesToChecklistItems(prev, masterRoutesMap);
    return next === prev ? prev : next;
  });
  setPromptAdditionCsv(prev => {
    const next = applyMasterNamesToPromptCsv(prev, masterRoutesMap);
    return next === prev ? prev : next;
  });
}, [masterRoutesMap]);


const writePodcastDetailsDoc = async ({ pid, nodeId, payload }) => {
  const db = getFirestore();
  const docRef = doc(db, "podcasts", pid, "podcast_details", nodeId);
  await setDoc(
    docRef,
    {
      ...payload,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
};

const loadAdditionalHouseholdNodes = async (nodeId) => {
  const id = String(nodeId || "").trim();
  if (!podcastId || !id) return [];
  try {
    const snap = await getDoc(doc(getFirestore(), "podcasts", podcastId, "podcast_details", id));
    const nodes = snap.exists() && Array.isArray(snap.data()?.additionalHouseholdNodes)
      ? snap.data().additionalHouseholdNodes.map(String).filter(Boolean)
      : [];
    setAdditionalHouseholdNodes(nodes);
    return nodes;
  } catch (error) {
    console.error("Failed to load additional household nodes:", error);
    setAdditionalHouseholdNodes([]);
    return [];
  }
};

const saveAdditionalHouseholdNodes = async (nodes) => {
  const primaryNodeId = String(nearestNodeIdRef.current || nearestNodeId || "").trim();
  if (!podcastId || !primaryNodeId) return;
  const normalized = [...new Set((nodes || []).map(String).map((id) => id.trim()).filter(Boolean))];
  setAdditionalNodesStatus("Saving…");
  try {
    await writePodcastDetailsDoc({
      pid: podcastId,
      nodeId: primaryNodeId,
      payload: { additionalHouseholdNodes: normalized },
    });
    setAdditionalHouseholdNodes(normalized);
    setAdditionalNodesStatus("Saved");
    if (selectedLocation && selectedSimulation) {
      await drawRoutes(
        selectedLocation.lat,
        selectedLocation.lng,
        time,
        selectedSimulation,
        destinationNodes,
        primaryNodeId
      );
    }
  } catch (error) {
    console.error("Failed to save additional household nodes:", error);
    setAdditionalNodesStatus("Save failed");
  }
};

const addAdditionalHouseholdNodeById = async (rawNodeId) => {
  const nodeId = String(rawNodeId || "").trim();
  const primaryNodeId = String(nearestNodeIdRef.current || nearestNodeId || "").trim();
  if (!nodeId || !graphData?.nodes?.[nodeId]) {
    window.alert("That node id is not in the current graph.");
    return;
  }
  if (nodeId === primaryNodeId) {
    window.alert("That is already the primary household node.");
    return;
  }
  if (additionalHouseholdNodes.includes(nodeId)) {
    setAdditionalNodesStatus(`Node ${nodeId} is already an additional household.`);
    return;
  }
  setAdditionalNodeIdText("");
  await saveAdditionalHouseholdNodes([...additionalHouseholdNodes, nodeId]);
};

const addAdditionalHouseholdNode = async () => {
  await addAdditionalHouseholdNodeById(additionalNodeIdText);
};

const savePromptChecklistOnly = async ({ silent = false } = {}) => {
  const pid = String(podcastId || "").trim();
  const nodeId = String(nearestNodeIdRef.current || nearestNodeId || "").trim();
  if (!pid || !nodeId) {
    if (!silent) setSaveMsg("Set podcastId/nodeId first.");
    return;
  }
  const { checklistItems, promptAdditionCsv } = buildChecklistItemsAndPromptCsv({
    destinationNodes,
    graphData,
    haversineDistance,
    masterRoutesMap,
    masterRoutesEntries,
    imageVariables,
  });
  setAutoChecklistItems(checklistItems);
  setPromptAdditionCsv(promptAdditionCsv);
  try {
    await writePodcastDetailsDoc({
      pid,
      nodeId,
      payload: {
        routeChecklistItems: checklistItems,
        promptAdditionCsv,
      },
    });
    if (!silent) setSaveMsg("Saved prompt/checklist ✅");
  } catch (err) {
    console.error(err);
    if (!silent) setSaveMsg("Failed to save prompt/checklist");
  }
};

const handleSaveRouteTables = async ({ silent = false } = {}) => {
  if (!silent) setSaveMsg("");

  const pid = String(podcastId || "").trim();
  if (!pid) {
    if (!silent) setSaveMsg("Set a podcastId first.");
    return;
  }

  if (!nearestNodeIdRef.current) {
    if (!silent) setSaveMsg("Pick a location on the map first so we know the nearest node.");
    return;
  }
  if (!Array.isArray(travelExperiences) || travelExperiences.length === 0) {
    if (!silent) setSaveMsg("No travel experiences yet. Click “Get travel narrative” first.");
    return;
  }

  try {
    setIsSavingRoutes(true);
    const tables = getRouteTables(travelExperiences, { masterRoutes: masterRoutesMap });

    const { checklistItems, promptAdditionCsv } = buildChecklistItemsAndPromptCsv({
      destinationNodes,
      graphData,
      haversineDistance,
      masterRoutesMap,
      masterRoutesEntries,
      imageVariables,
    });

    // keep UI in sync too
    setAutoChecklistItems(checklistItems);
    setPromptAdditionCsv(promptAdditionCsv);

    await writePodcastDetailsDoc({
      pid,
      nodeId: String(nearestNodeIdRef.current),
      payload: {
        routeTables: tables,
        routeChecklistItems: checklistItems,
        promptAdditionCsv,
      },
    });

    if (!silent) setSaveMsg("Saved route tables ✅");
  } catch (e) {
    console.error(e);
    if (!silent) setSaveMsg("Failed to save route tables.");
  } finally {
    setIsSavingRoutes(false);
  }
};

const handleMasterRoutesSaved = (meta = {}) => {
  const reason = String(meta?.reason || "");
  masterRoutesByNodeCacheRef.current.clear();
  handleSaveRouteTables({ silent: true });
  savePromptChecklistOnly({ silent: true });
  // Redraw only for explicit route-edit saves; skip bootstrap/autosave to avoid flicker.
  if (reason !== "route-edit-save") return;
  if (!selectedLocation || !selectedSimulation) return;

  if (redrawAfterMasterSaveTimerRef.current) {
    clearTimeout(redrawAfterMasterSaveTimerRef.current);
  }
  redrawAfterMasterSaveTimerRef.current = setTimeout(() => {
    wantRoutesAutoplayRef.current = false;
    drawRoutes(
      selectedLocation.lat,
      selectedLocation.lng,
      time,
      selectedSimulation,
      destinationNodes
    );
  }, 350);
};

useEffect(() => () => {
  if (redrawAfterMasterSaveTimerRef.current) {
    clearTimeout(redrawAfterMasterSaveTimerRef.current);
  }
}, []);

useEffect(() => {
  const ready =
    Array.isArray(destinationNodes) && destinationNodes.length > 0 &&
    graphData && Array.isArray(graphData.links) && graphData.links.length > 0 &&
    graphData.nodes && Object.keys(graphData.nodes).length > 0;

  if (!ready) return;

  const { checklistItems, promptAdditionCsv } = buildChecklistItemsAndPromptCsv({
    destinationNodes,
    graphData,
    haversineDistance,
    masterRoutesMap,
    masterRoutesEntries,
    imageVariables,
  });

  setAutoChecklistItems(checklistItems);
  setPromptAdditionCsv(promptAdditionCsv);
}, [destinationNodes, graphData, masterRoutesMap, masterRoutesEntries, imageVariables]);

// One animation loop per polyline
const linkAnimRef = useRef(new Map()); // polyline -> { raf, spawnTimer, cars:[], color:"#186EE3", fft:5 }
const STOP_ANIMS = () => {
  linkAnimRef.current.forEach(({ raf, spawnTimer, poly }) => {
    if (raf) cancelAnimationFrame(raf);
    if (spawnTimer) clearInterval(spawnTimer);
    // also clear icons so no dots are left
    if (poly) poly.set('icons', []);
  });
  linkAnimRef.current.clear();
};

// show/hide the animated dots on a given polyline
const SET_LINK_ANIM_VISIBLE = (poly, visible) => {
  const st = linkAnimRef.current.get(poly);
  if (!st) return;
  st.visible = !!visible;
  if (!visible) {
    // immediately clear any existing dots
    try { st.poly.set('icons', []); } catch (_) {}
  }
};

// start or restart animation for a single polyline
const START_LINK_ANIM = (poly, color, fftSec) => {
  const prev = linkAnimRef.current.get(poly);
  if (prev) {
    if (prev.raf) cancelAnimationFrame(prev.raf);
    if (prev.spawnTimer) clearInterval(prev.spawnTimer);
  }

  const state = {
    poly,
    color,                 // moving-dot color, and also used for stroke
    baseColor: color,      // remember original so we can restore after a scene
    baseQueueColor: color,
    fft: Math.max(0.5, Number(fftSec) || 5),
    cars: [],              // { born:number(ms) }
    raf: 0,
    spawnTimer: 0,
    running: true,
    visible: true,
    queue: {
      count: 0,
      spacingPct: 4,
      color: '#186EE3',    // default queue-dot color
      multiplier: 1        // scene override scales this
    }
  };

  // spawn a new car every 2s (change to 1000 if you want the old rate)
  state.spawnTimer = setInterval(() => {
    state.cars.push({ born: performance.now() });
    if (state.cars.length > 120) state.cars.splice(0, state.cars.length - 120);
  }, 2000);

  const tick = () => {
    if (!state.running) return;
    const now = performance.now();
    const icons = [];
    const durMs = state.fft * 1000;

    const gm = window?.google?.maps;
    if (!gm) {
      state.raf = requestAnimationFrame(tick);
      return;
    }

    if (!state.visible) {
      state.poly.set('icons', []);
      state.raf = requestAnimationFrame(tick);
      return;
    }

    // Effective queued count after scene multiplier
    const q = state.queue;
    const effectiveCount = Math.max(0, Math.floor((q.count || 0) * (q.multiplier || 1)));
    const queuedSpanPct = effectiveCount * Math.max(1, q.spacingPct);
    const freeEndPct = Math.max(0, 100 - queuedSpanPct);

    // moving dots only in the free portion
    for (let i = state.cars.length - 1; i >= 0; i--) {
      const age = now - state.cars[i].born;
      if (age >= durMs) { state.cars.splice(i, 1); continue; }
      const travelPct = Math.min(100, (age / durMs) * 100);
      if (travelPct <= freeEndPct) {
        icons.push({
          icon: {
            path: gm.SymbolPath.CIRCLE,
            scale: 5,
            strokeOpacity: 0,
            fillOpacity: 1,
            fillColor: state.color
          },
          offset: `${travelPct}%`
        });
      }
    }

    // queued dots from the end backward (clipped to link)
    if (effectiveCount > 0) {
      const qIcon = {
        path: gm.SymbolPath.CIRCLE,
        scale: 5,
        strokeOpacity: 0,
        fillOpacity: 1,
        fillColor: q.color || '#FF3B30'
      };
      for (let i = 0; i < effectiveCount; i++) {
        const offsetFromEnd = i * Math.max(1, q.spacingPct);
        const offset = 100 - offsetFromEnd;
        if (offset < freeEndPct) break;
        icons.push({ icon: qIcon, offset: `${Math.max(freeEndPct, Math.min(100, offset))}%` });
      }
    }

    state.poly.setOptions({ strokeOpacity: 0.35, strokeColor: state.color });
    state.poly.set('icons', icons);
    state.raf = requestAnimationFrame(tick);
  };

  state.raf = requestAnimationFrame(tick);
  linkAnimRef.current.set(poly, state);
};

// update color (e.g., when you flip a link to orange)
const UPDATE_LINK_ANIM_COLOR = (poly, newColor) => {
  const st = linkAnimRef.current.get(poly);
  if (st) st.color = newColor;
};

const SET_LINK_QUEUE = (poly, count, spacingPct = 4, color) => {
  const st = linkAnimRef.current.get(poly);
  if (!st) return;
  st.queue.count = Math.max(0, Math.floor(Number(count) || 0));
  st.queue.spacingPct = Math.max(1, Number(spacingPct) || 4);
  if (color) {
    st.queue.color = color;
    st.baseQueueColor = st.baseQueueColor || color;  // <— capture once
  }
  
};

const APPLY_TRAFFIC_OVERRIDE = (spec) => {
  const color = spec?.color;
  const mult = spec?.congestionMultiplier;
  linkAnimRef.current.forEach((st) => {
    if (color) {
      st.color = color;        // moving dots and stroke
      st.queue.color = color;  // queued dots match scene color
    }
    if (typeof mult === 'number' && !Number.isNaN(mult)) {
      st.queue.multiplier = Math.max(0, mult);
    }
  });
};

const CLEAR_TRAFFIC_OVERRIDE = () => {
  linkAnimRef.current.forEach((st) => {
    st.color = st.baseColor || st.color;
    st.queue.multiplier = 1;
    st.queue.color = st.baseQueueColor || '#186EE3';
    // keep whatever queue color was set by API or default red
  });
};

const activeScenesRef = useRef(ROUTE_SCENES);
useEffect(() => {
  activeScenesRef.current = isEnglish ? ROUTE_SCENES : ROUTE_SCENES_OLD;
}, [isEnglish]);

// Load "Podcast media/ResourcesV1.mp4" once
useEffect(() => {
  const storage = getStorage();
  getDownloadURL(storageRef(storage, "Podcast media/ResourcesV1.mp4"))
    .then(setResourcesAudioUrl)
    .catch(err => console.error("Error fetching resources audio:", err));
}, []);

useEffect(() => {
  if (prefillDoneRef.current) return;

  const qs = typeof window !== "undefined" ? window.location.search : "";
  if (!qs) return;

  const params = new URLSearchParams(qs.replace(/\?\s*/, "?").replace(/&&/g, "&"));
  const langParam = params.get("lang");
  const streetParam = params.get("street");

  if (langParam) {
    const L = String(langParam).trim().toUpperCase();
    if (L === "EN" || L === "ES") setSelectedLanguage(L);
  }

  const graphReady = graphData && Object.keys(graphData.nodes || {}).length > 0;
  const destReady = Array.isArray(destinationNodes) && destinationNodes.length > 0;
  const ready = !!selectedSimulation && destReady && graphReady && mapReady;

  if (streetParam && ready) {
    const streetText = decodeURIComponent(streetParam).replace(/\+/g, " ").trim();
    setSearchText(streetText);

    /*(async () => {
      try {
        setIsSearchingLoc(true);
        const { lat, lng } = await geocodeAddress(streetText, "", "");
        const latNum = +lat, lngNum = +lng;

        setSelectedLocation({ lat: latNum, lng: lngNum });

        if (mapRef.current) {
          modifyMapCamera(mapRef.current, { lat: latNum, lng: lngNum }, 14.5, 1000);
        }

        await drawRoutes(latNum, lngNum, time, selectedSimulation, destinationNodes);

        // Only mark done after a successful draw
        prefillDoneRef.current = true;
      } catch (e) {
        console.error("Prefill geocode/draw failed:", e);
        // do not mark done so it can retry when prerequisites change
      } finally {
        setIsSearchingLoc(false);
      }
    })();*/
  }
}, [selectedSimulation, destinationNodes, time, graphData, mapReady]);

const resourceSegments = React.useMemo(
  () => getResourceSegments(isEnglish ? 'EN' : 'ES'),
  [isEnglish]
);

const stopResourcePlayback = () => {
  const a = resourcesAudioRef.current;
  if (a) a.pause();
  setActiveResourceKey(null);
};

const playResourceSegment = (seg) => {
  const a = resourcesAudioRef.current;
  if (!a || !resourcesAudioUrl) return;

  // Toggle stop if clicking the active item
  if (activeResourceKey === seg.key) {
    stopResourcePlayback();
    return;
  }

  // Start this snippet
  setActiveResourceKey(seg.key);
  a.currentTime = seg.start;
  a.play().catch(() => {}); // ignore brief play() race
  setResourceProgress(p => ({ ...p, [seg.key]: 0 }));
};

// Keep per-item relative progress & auto-stop at segment end
useEffect(() => {
  const a = resourcesAudioRef.current;
  if (!a) return;

  const onTime = () => {
    const seg = resourceSegments.find(s => s.key === activeResourceKey);
    if (!seg) return;

    if (a.currentTime >= seg.end) {
      stopResourcePlayback();
      a.currentTime = seg.end;
      return;
    }

    const rel = Math.max(0, a.currentTime - seg.start);
    const dur = Math.max(0, seg.end - seg.start);
    setResourceProgress(prev => ({ ...prev, [seg.key]: Math.min(rel, dur) }));
  };

  const onEnded = () => stopResourcePlayback();

  a.addEventListener("timeupdate", onTime);
  a.addEventListener("ended", onEnded);
  return () => {
    a.removeEventListener("timeupdate", onTime);
    a.removeEventListener("ended", onEnded);
  };
}, [activeResourceKey, resourceSegments, resourcesAudioUrl]);



const setSafetyCalloutsVisible = (show) => {
  if (!safetyCalloutsRef.current) return;
  safetyCalloutsRef.current.forEach(ov => {
    if (!ov) return;
    ov.setMap(show ? mapRef.current : null);
  });
};

// Create (or update) a polyline for a link id with a given color
const ensureLinkPolyline = (linkId, color = "#186EE3") => {
  const id = String(linkId);
  const map = mapRef.current;
  if (!map) return null;

  let poly = storyboardLinkPolysRef.current.get(id);
  if (!poly) {
    const wkt = linkGeomsRef.current[id];
    if (!wkt) return null;
    const coords = wkt
      .replace(/^LINESTRING\s*\(/i, "")
      .replace(/\)$/, "")
      .split(",")
      .map(pt => {
        const [lng, lat] = pt.trim().split(" ").map(Number);
        return { lat, lng };
      });

    poly = new window.google.maps.Polyline({
      path: coords,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 1,
      strokeWeight: 5,
      zIndex: 1000,
      clickable: false
    });
    storyboardLinkPolysRef.current.set(id, poly);
  }

  poly.setOptions({ strokeColor: color, strokeOpacity: 1 });
  if (!poly.getMap()) poly.setMap(map);
  return poly;
};

// Create (or update) a marker for a node id
const ensureNodeMarker = (nodeId, { iconUrl, color } = {}) => {
  const id = String(nodeId);
  const map = mapRef.current;
  if (!map || !graphData?.nodes?.[id]) return null;

  let marker = storyboardNodeMarkersRef.current.get(id);
  const { lat, lng } = graphData.nodes[id];

  const makeIcon = () => {
    if (iconUrl) {
      return {
        url: iconUrl,
        scaledSize: new window.google.maps.Size(40, 40),
        anchor: new window.google.maps.Point(20, 20),
      };
    }
    // simple colored dot if no icon
    const pinSvg = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="${color || "#186EE3"}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" />
      </svg>`;
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(pinSvg),
      scaledSize: new window.google.maps.Size(24, 24),
      anchor: new window.google.maps.Point(12, 12),
    };
  };

  if (!marker) {
    marker = new window.google.maps.Marker({
      position: { lat, lng },
      map,
      icon: makeIcon(),
      opacity: 1,
    });
    storyboardNodeMarkersRef.current.set(id, marker);
  } else {
    marker.setPosition({ lat, lng });
    marker.setIcon(makeIcon());
    if (!marker.getMap()) marker.setMap(map);
  }
  return marker;
};

const ensureCustomMarker = ({ key, lat, lng, iconUrl, color }) => {
  const map = mapRef.current;
  if (!map || typeof lat !== "number" || typeof lng !== "number") return null;

  const id = String(key || `latlng:${lat},${lng}`);
  let marker = storyboardNodeMarkersRef.current.get(id);

  const makeIcon = () => {
    if (iconUrl) {
      return {
        url: iconUrl,
        scaledSize: new window.google.maps.Size(60, 60),
        anchor: new window.google.maps.Point(20, 20),
      };
    }
    const pinSvg = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="${color || "#186EE3"}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" />
      </svg>`;
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(pinSvg),
      scaledSize: new window.google.maps.Size(24, 24),
      anchor: new window.google.maps.Point(12, 12),
    };
  };

  if (!marker) {
    marker = new window.google.maps.Marker({
      position: { lat, lng },
      map,
      icon: makeIcon(),
      opacity: 1,
    });
    storyboardNodeMarkersRef.current.set(id, marker);
  } else {
    marker.setPosition({ lat, lng });
    marker.setIcon(makeIcon());
    if (!marker.getMap()) marker.setMap(map);
  }
  return marker;
};

// Hide everything created by the storyboard
const hideAllStoryboardOverlays = () => {
  storyboardLinkPolysRef.current.forEach(poly => poly.setMap(null));
  storyboardNodeMarkersRef.current.forEach(m => m.setMap(null));
  storyboardFirePolysRef.current.forEach(p => p.setMap(null)); 
  storyboardFirePolysRef.current = [];                         
};

// Apply a storyboard "scene" object { camera, links[], nodes[], ... }
const applyStoryboardScene = (scene) => {
  if (!scene) return;

  // Camera (smooth if changed)
  if (scene.camera && mapRef.current) {
    const { center, zoom } = scene.camera;
    const last = lastStoryboardCameraRef.current;
    const changed =
      !last ||
      Math.abs((last.center?.lat ?? 0) - center.lat) > 1e-6 ||
      Math.abs((last.center?.lng ?? 0) - center.lng) > 1e-6 ||
      (last.zoom !== zoom);

    if (changed) {
      modifyMapCamera(mapRef.current, center, zoom, 1000);
      lastStoryboardCameraRef.current = { center, zoom };
    }
  }

  // LINKS: force red + high z-index unless overridden in scene
  const visibleLinks = new Set();
  (scene.links || []).forEach(l => {
    const poly = ensureLinkPolyline(l.id, l.color || "#FF0000");
    if (poly) {
      poly.setOptions({
        strokeColor: l.color || "#FF0000",
        zIndex: typeof l.zIndex === "number" ? l.zIndex : 9999,
        strokeOpacity: 1
      });
      visibleLinks.add(String(l.id));
    }
  });
  storyboardLinkPolysRef.current.forEach((poly, id) => {
    if (!visibleLinks.has(id)) poly.setMap(null);
  });

  // Markers (nodes + custom icons share one registry)
  const visibleMarkerKeys = new Set();

  // Legacy node markers still supported
  (scene.nodes || []).forEach(n => {
    const marker = ensureNodeMarker(n.nodeId, { iconUrl: n.iconUrl, color: n.color });
    if (marker) visibleMarkerKeys.add(String(n.nodeId));
  });

  // NEW: icons by lat/lng; currently supports { type: "flag", lat, lng, key? }
  (scene.icons || []).forEach(icon => {
      if (typeof icon.lat !== "number" || typeof icon.lng !== "number") return;
      const type = String(icon.type || "flag").toLowerCase();
      const iconUrl =
        type === "parking" ? ParkingIconGreen : /* school uses flag too */ SafetyIcon;
      const key = String(icon.key || `${type}:${icon.lat},${icon.lng}`);
      const marker = ensureCustomMarker({
        key,
        lat: icon.lat,
          lng: icon.lng,
          iconUrl
        });
        if (marker) visibleMarkerKeys.add(key);
      });

  // Hide any storyboard markers not declared in this scene
  storyboardNodeMarkersRef.current.forEach((m, id) => {
    if (!visibleMarkerKeys.has(id)) m.setMap(null);
  });

  storyboardFirePolysRef.current.forEach(p => p.setMap(null));
  storyboardFirePolysRef.current = [];

  if (scene.firePolygons && scene.firePolygons.length && mapRef.current) {
    // Reuse an existing fire color (latest/highest zIndex one if present)
    const baseColor = (firePolygons && firePolygons[0] && firePolygons[0].color) || "rgb(255,69,0)";

    scene.firePolygons.forEach(fp => {
      const polygon = new window.google.maps.Polygon({
        paths: fp.path,
        fillColor: baseColor,
        fillOpacity: 0.8,
        strokeColor: baseColor,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        map: mapRef.current,
        zIndex: 9998
      });
      storyboardFirePolysRef.current.push(polygon);
    });
  }
};

// Given a current time (seconds), find the scene and apply it
const applyStoryboardForTime = (tSec) => {
  const scenes = activeScenesRef.current || [];
  if (!scenes.length) {
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setActiveCallout(null);
    setBalloonsSpec(null);
    CLEAR_TRAFFIC_OVERRIDE();
    return;
  }
  const scene = scenes.find(s => tSec >= s.start && tSec < s.end);
  if (!scene) {
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setActiveCallout(null);
    setBalloonsSpec(null);
    CLEAR_TRAFFIC_OVERRIDE();
    return;
  }
  applyStoryboardScene(scene);
  setActiveCallout(scene.callout || null);
  setBalloonsSpec(scene.balloons || null);

  if (scene.trafficAnimation) {
    APPLY_TRAFFIC_OVERRIDE(scene.trafficAnimation);
  } else {
    CLEAR_TRAFFIC_OVERRIDE();
  }
};


  // Fetch podcast audio URL on mount.
  useEffect(() => {
    const storage = getStorage();
    const podcastRefStorage = storageRef(storage, 'Podcast media/street-podcasts/Lakeview-drive/Lakeview-Drive_1760158856.mp3');
    getDownloadURL(podcastRefStorage)
      .then((url) => { setPodcastAudioUrl(url); })
      .catch((error) => { console.error("Error fetching podcast audio:", error); });

  }, []);

  useEffect(() => {
    if (!selectedSimulation) return;
  
    // Clear out any previous graph data immediately
    setGraphData({ links: [], nodes: {}, adjList: {} });
  
    const storage = getStorage();
    const csvRef = storageRef(
      storage,
      `${selectedSimulation.id}/inputs/berkeley_links.csv`
    );
  
    getDownloadURL(csvRef)
      .then(url => fetch(url))
      .then(response => response.text())
      .then(csvText => {
        const parsed = parseCSV(csvText);
  
        const nodes = {};
        parsed.forEach(row => {
          const startId = row.start_node_id;
          const endId   = row.end_node_id;
          const geom    = row.geometry
            .replace(/LINESTRING\s*\(/, '')
            .replace(/\)$/, '');
          const coordsArr = geom
            .split(',')
            .map(s => s.trim().split(' ').map(Number));
  
          if (coordsArr.length) {
            const [lng0, lat0] = coordsArr[0];
            const [lngN, latN] = coordsArr[coordsArr.length - 1];
            nodes[startId] = { id: startId, lat: lat0, lng: lng0 };
            nodes[endId]   = { id: endId,   lat: latN, lng: lngN };
          }
        });
  
        const adjList = {};
        parsed.forEach(row => {
          const start  = row.start_node_id;
          const end    = row.end_node_id;
          const length = parseFloat(row.length);
  
          if (!adjList[start]) adjList[start] = [];
          if (!adjList[end])   adjList[end]   = [];
  
          adjList[start].push({ node: end, weight: length, link: row });
        });

        console.log(parsed)
  
        setGraphData({ links: parsed, nodes, adjList });

        console.log("Links ", parsed)

        // Keep global WKT lookup in sync for storyboard
        const linkGeoms = {};
        parsed.forEach(row => {
          linkGeoms[row.link_id] = row.geometry;
        });
        linkGeomsRef.current = linkGeoms;
      })
      .catch(error => console.error('Error fetching CSV:', error));

      fetchAllFireData(selectedSimulation.id)
  }, [selectedSimulation]);

useEffect(() => {
  const fetchSimulations = async () => {
    try {
      const simsCol   = collection(firestore, 'simulations');
      const simDocs   = await getDocs(simsCol);
      const simList   = simDocs.docs.map(d => ({ id: d.id, ...d.data() }));
      setSimulations(simList);
    } catch (err) {
      console.error('Error fetching simulations:', err);
    }
  };
    fetchSimulations();
  }, []);

  useEffect(() => {
    if (!selectedSimulation) return;                       // need the ID
  
    const storage = getStorage();
    const nodesRef = storageRef(
      storage,
      `${selectedSimulation.id}/inputs/berkeley_nodes.csv`
    );
  
    getDownloadURL(nodesRef)
      .then(url => fetch(url))
      .then(res => res.text())
      .then(csv => {
        const rows = parseCSV(csv);                        // you already have parseCSV
        const dests = rows
          .filter(r => r.type === 'destination')
          .map(r => ({ nodeId: r.node_id, name: r.name || r.node_id }));
        setDestinationNodes(dests);                        // update state

        console.log("Destination", dests)
      })
      .catch(err => console.error('Error loading nodes CSV:', err));
  }, [selectedSimulation]);

  // Language-aware routes audio loader
useEffect(() => {
  const storage = getStorage();
  const FILE_EN = "Podcast media/street-podcasts/Lakeview-drive/Lakeview-Drive_1760158856.mp3";
  // const FILE_ES = "Podcast media/Longview_Drive_Wildfire_Evacuation_ES.m4a";
  const FILE_ES = "Podcast media/Harborview-Drive-ES.mp3";
  const targetPath = (selectedLanguage === 'ES') ? FILE_ES : FILE_EN;

  // Stop & reset any currently playing audio when switching languages
  if (routesAudioRef.current) {
    try {
      routesAudioRef.current.pause();
      routesAudioRef.current.currentTime = 0;
    } catch (_) {}
  }

  (async () => {
    try {
      const url = await getDownloadURL(storageRef(storage, targetPath));
      setRoutesAudioUrl(url);
    } catch (err) {
      console.error("Error fetching language-specific routes audio:", err);
      // Fallback to English if ES isn’t found
      if (selectedLanguage === 'ES') {
        try {
          const urlEn = await getDownloadURL(storageRef(storage, FILE_EN));
          setRoutesAudioUrl(urlEn);
        } catch (err2) {
          console.error("Fallback (EN) also failed:", err2);
          setRoutesAudioUrl(""); // keep player empty on failure
        }
      } else {
        setRoutesAudioUrl("");
      }
    }
  })();
}, [selectedLanguage]);
  

useEffect(() => {
  if (selectedTab !== "routes") {
    STOP_ANIMS();    
    updateRouteOpacity(null);
    cancelRouteEdit();
    setFocusedMasterRouteNodeId(null);
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setIsPodcastPlaying(false);
    setSafetyCalloutsVisible(true);
    setBalloonsSpec(null);
    setActiveCallout(null);
  }
}, [selectedTab, cancelRouteEdit]);

  // CSV parser helper.
  const parseCSV = (text) => {
    const lines = text.split('\n').filter(line => line.trim() !== '');
    const header = lines[0].split(',');
    const data = [];
    const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
    for (let i = 1; i < lines.length; i++) {
      let row = lines[i].split(regex);
      const obj = {};
      header.forEach((col, index) => {
        obj[col] = row[index] ? row[index].replace(/^"|"$/g, '') : '';
      });
      data.push(obj);
    }
    return data;
  };

  const clearAndSetFirePolygons = (polys) => {
    const map = mapRef.current;
    // remove any existing
    firePolygonsRef.current.forEach(p => p && p.setMap(null));
    firePolygonsRef.current = [];
  
    // draw the new ones
    polys.forEach((p, idx) => {
      const polygon = new window.google.maps.Polygon({
        paths: p.path,
        fillColor: p.color,
        fillOpacity: 0.8,
        strokeColor: p.color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        map,
        zIndex: idx
      });
      firePolygonsRef.current.push(polygon);
    });
  
    setFirePolygons(polys);
  };

  const fetchAllFireData = async (simulationId) => {
       const storage    = getStorage();
       const prefixRef  = storageRef(storage, `${simulationId}/fire_inputs/`);
       const listResult = await listAll(prefixRef);
    
       // 1) load every geojson file
       const rawPolys = [];
       await Promise.all(
         listResult.items
           .filter(item => item.name.endsWith(".geojson"))
           .map(async item => {
             const m = item.name.match(/fire_(\d+)\.geojson$/);
             if (!m) return;
             const time = parseInt(m[1], 10);
             const url  = await getDownloadURL(item);
             const json = await (await fetch(url)).json();
             (json.features || []).forEach(f => {
               rawPolys.push({
                 time,
                 path: f.geometry.coordinates[0].map(([lng,lat])=>({lat,lng}))
               });
             });
           })
       );
    
       // 2) dedupe identical shapes
       const seen = new Set();
       const uniq = [];
       rawPolys.forEach(p => {
         const key = JSON.stringify(p.path);
         if (!seen.has(key)) {
           seen.add(key);
           uniq.push(p);
         }
       });
    
       if (uniq.length === 0) {
         clearAndSetFirePolygons([]);
         return;
       }
    
       // 3) sort by time descending (latest first)
       uniq.sort((a,b) => b.time - a.time);
    
       // 4) assign a colour gradient yellow→red
       const N = uniq.length;
       uniq.forEach((p,i) => {
         const t   = (N-1-i) / (N - 1 || 1);
         const g   = Math.round(255 - (255 - 69) * t);
         p.color   = `rgb(255,${g},0)`;
       });
    
       // 5) draw stacked
       clearAndSetFirePolygons(uniq);
     };
  
  

     const handleGetTravelExperience = async () => {
      if (!selectedLocation) {
        window.alert("Click on the map first to choose your starting point.");
        return;
      }
      if (!podcastId) {
        window.alert("Missing podcastId in URL. Use /edit_podcast/<podcastId>");
        return;
      }
      const nodeId = String(nearestNodeIdRef.current || nearestNodeId || "").trim();
      if (!nodeId) {
        window.alert("Pick a location first so we know the nearest node.");
        return;
      }
    
      const db = getFirestore();
      const narrativeDocRef = doc(db, "podcasts", podcastId, "travel_narrative", nodeId);
      const detailsDocRef   = doc(db, "podcasts", podcastId, "podcast_details", nodeId);
    
      try {
        setIsGeneratingTravelNarrative(true);
        const targetDestinations = filteredDestinationNodes;
        if (masterRouteDestinationIds.size > 0 && targetDestinations.length === 0) {
          window.alert("None of the destinations in the route-links master exist in this simulation.");
          return;
        }

        const detailsSnap = await getDoc(detailsDocRef);
        const constrainedRoutes = detailsSnap.exists()
          ? ((detailsSnap.data() || {}).constrainedRoutes || {})
          : {};

        const exp = await getTravelExperiencesSimple({
          lat: selectedLocation.lat,
          lng: selectedLocation.lng,
          graphData,
          destinationNodes: targetDestinations,
          selectedTime: Number(time),
          simulation: selectedSimulation,
          oneCarSimulationId,
          apiAbortSignal: apiCallControllerRef.current?.signal,
          constrainedRoutes,
        });
    
        setTravelExperiences(exp);
    
        const routeRows = getTravelRouteRows(exp, { masterRoutes: masterRoutesMap });
        const narrative = buildTravelNarrativeV4(exp, selectedLocation, Number(time), {
          masterRoutes: masterRoutesMap,
          nodeId,
          routeRows
        });
        setTravelExpNarrativeStream(narrative);
    
        // Route tables + prompt CSV
        const tables = getRouteTablesFromRows(routeRows);
        setRouteTablesDraft(JSON.stringify(tables, null, 2));
        const built = buildChecklistItemsAndPromptCsv({
          destinationNodes,
          graphData,
          haversineDistance,
          masterRoutesMap,
          masterRoutesEntries,
          imageVariables,
        });
        setAutoChecklistItems(built.checklistItems);
        setPromptAdditionCsv(built.promptAdditionCsv);
    
        // Save BOTH in one batch
        const batch = writeBatch(db);
    
        batch.set(
          narrativeDocRef,
          {
            narrative,
            updatedAt: serverTimestamp(),
            createdAt: serverTimestamp(),
            nodeId,
          },
          { merge: true }
        );
    
        batch.set(
          detailsDocRef,
          {
            routeTables: tables,
            routeChecklistItems: built.checklistItems,
            promptAdditionCsv: built.promptAdditionCsv,
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        );
    
        await batch.commit();
      } catch (err) {
        console.error("Could not get/save travel narrative:", err);
      } finally {
        setIsGeneratingTravelNarrative(false);
      }
    };
 

  // Function to play podcast audio.
  const playSection = (startTime) => {
    if (podcastAudioRef.current) {
      podcastAudioRef.current.currentTime = startTime;
      //podcastAudioRef.current.play();
    }
  };

  const playRouteSection = (startTime) => {
    if (routesAudioRef.current) {
      routesAudioRef.current.currentTime = startTime;
      // routesAudioRef.current.play();
    }
  };

  const handleNodeIdSubmit = () => {
    const raw = String(nodeIdText).trim();
    if (!raw) return;
  
    const id = raw; // keep as string; your nodes keys are strings
    if (!graphData?.nodes?.[id]) {
      window.alert("That node id is not in the current graph.");
      return;
    }
  
    const { lat, lng } = graphData.nodes[id];
  
    setSelectedLocation({ lat, lng });
    if (mapRef.current) {
      modifyMapCamera(mapRef.current, { lat, lng }, 14.5, 800);
    }
  
    if (selectedSimulation) {
      cancelRouteEdit();
      setFocusedMasterRouteNodeId(null);
      wantRoutesAutoplayRef.current = false;
      drawRoutes(lat, lng, time, selectedSimulation, destinationNodes, id);
    }
  };

  const createTextOverlay = (position, text) => {
    const overlay = new window.google.maps.OverlayView();
    overlay.onAdd = function() {
      this.div = document.createElement("div");
      // Style the overlay div as desired:
      this.div.style.position = "absolute";
      this.div.style.background = "rgba(255, 255, 255, 0.9)";
      this.div.style.color = "#000";
      this.div.style.padding = "2px 4px";
      this.div.style.borderRadius = "4px";
      this.div.style.fontSize = "16px";
      this.div.innerHTML = text;
      const panes = this.getPanes();
      panes.floatPane.appendChild(this.div);
    };
    overlay.draw = function() {
      const projection = this.getProjection();
      // Convert the geographical position to pixel coordinates.
      const point = projection.fromLatLngToDivPixel(new window.google.maps.LatLng(position.lat, position.lng));
      if (point && this.div) {
        // Adjust the position so the overlay appears centered above the marker.
        this.div.style.left = (point.x - this.div.offsetWidth / 2) + "px";
        this.div.style.top = (point.y - this.div.offsetHeight - 20) + "px"; // 5px above
      }
    };
    overlay.onRemove = function() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    };
    overlay.setMap(mapRef.current);
    return overlay;
  };

  const apiCallControllerRef = useRef(null);

  const getDominantStreetName = (nodeId, links) => {
    const counts = new Map(); // name -> {count, firstIdx}
    let idx = 0;
    for (const row of links || []) {
      const sid = String(row.start_node_id);
      const eid = String(row.end_node_id);
      if (String(nodeId) === sid || String(nodeId) === eid) {
        const nm = (row.name || "").trim();
        if (!nm) { idx++; continue; }
        if (!counts.has(nm)) counts.set(nm, { count: 0, firstIdx: idx });
        const rec = counts.get(nm);
        rec.count += 1;
      }
      idx++;
    }
    let best = "";
    let bestCount = -1;
    let bestFirst = Infinity;
    for (const [nm, rec] of counts.entries()) {
      if (rec.count > bestCount || (rec.count === bestCount && rec.firstIdx < bestFirst)) {
        best = nm; bestCount = rec.count; bestFirst = rec.firstIdx;
      }
    }
    return best || "";
  };

  const drawRoutes = async (lat, lng, selectedTime, selectedSimulation, dests, forceNodeId = null) => {
    if (!dests || dests.length === 0) return;
  
    // Abort any ongoing calls
    if (apiCallControllerRef.current) apiCallControllerRef.current.abort();
    apiCallControllerRef.current = new AbortController();
  
    // Location marker
    if (circleRef.current) circleRef.current.setMap(null);
    const locationMarker = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: { url: LocationIcon, scaledSize: new window.google.maps.Size(50, 50), anchor: new window.google.maps.Point(25, 25) },
    });
    circleRef.current = locationMarker;
  
    // Clear old overlays
    STOP_ANIMS(); 
    polylineRefs.current.forEach(poly => poly.setMap(null));
    polylineRefs.current = [];
    carMarkersRef.current.forEach(marker => marker.setMap(null));
    carMarkersRef.current = [];
    additionalHouseMarkersRef.current.forEach(marker => marker.setMap(null));
    additionalHouseMarkersRef.current = [];
    routesDataRef.current = [];
    setRouteLinkSnapshots([]);
    if (safetyCalloutsRef.current && safetyCalloutsRef.current.length > 0) {
      safetyCalloutsRef.current.forEach(callout => callout.setMap(null));
      safetyCalloutsRef.current = [];
    }
  
    if (!graphData.nodes || Object.keys(graphData.nodes).length === 0) return;
  
    // Build link geometry lookup
    const linkGeoms = {};
    (graphData.links || []).forEach(row => { linkGeoms[row.link_id] = row.geometry; });
    linkGeomsRef.current = linkGeoms;
  
    // Find nearest node to click
    let nearestNodeId = null, minDist = Infinity;
    if (forceNodeId != null && graphData.nodes[String(forceNodeId)]) {
      nearestNodeId = String(forceNodeId);
      const n = graphData.nodes[nearestNodeId];
      lat = n.lat;
      lng = n.lng;
    } else {
      for (const node of Object.values(graphData.nodes)) {
        const d = haversineDistance(lat, lng, node.lat, node.lng);
        if (d < minDist) { minDist = d; nearestNodeId = node.id; }
      }
    }
    if (nearestNodeId == null) return;
    nearestNodeIdRef.current = nearestNodeId;
    setNearestNodeId(String(nearestNodeId));
    setEditingNodeId(nearestNodeIdRef.current);
    const householdNodesForDraw = await loadAdditionalHouseholdNodes(nearestNodeId);

    const dominantStreet = getDominantStreetName(nearestNodeId, graphData.links);
    console.log("Dominant street", dominantStreet)
    setSelectedLocation(prev => ({ ...(prev || {}), lat, lng, street: dominantStreet || (prev?.street || "") }));

    // Always check master-routes storage for this node before deciding route source.
    const checkedMaster = await ensureMasterRoutesForNode(nearestNodeId);
    const masterEntriesForDraw =
      Array.isArray(checkedMaster?.entries) ? checkedMaster.entries : [];
    const masterMapForDraw = checkedMaster?.map || {};
  
    // Prefer master route-links when available; fallback to route selector otherwise.
    const destById = new Map();
    (Array.isArray(dests) ? dests : []).forEach((d) => {
      const id = String(d?.nodeId ?? "").trim();
      if (id) destById.set(id, d);
    });
    const masterCandidateEntries = masterEntriesForDraw.length > 0
      ? masterEntriesForDraw
      : Object.values(masterMapForDraw);
    const seenMasterNodes = new Set();
    const masterSelectedRoutes = masterCandidateEntries
      .map((entry) => {
        const nodeId = String(entry?.id || entry?.key || "").trim();
        const linkIds = (Array.isArray(entry?.links) ? entry.links : [])
          .map((l) => String(l?.id ?? "").trim())
          .filter(Boolean);
        if (!nodeId || !destById.has(nodeId) || linkIds.length === 0 || seenMasterNodes.has(nodeId)) return null;
        seenMasterNodes.add(nodeId);
        return { nodeId, link_ids: linkIds, source: "master" };
      })
      .filter(Boolean);

    const selectedRoutes = masterSelectedRoutes.length > 0
      ? masterSelectedRoutes
      : selectTwoDiverseRoutesSimple({
          graphData,
          nearestNodeId,
          dests
        });
    console.log("Selected routes", selectedRoutes)
    if (!selectedRoutes || selectedRoutes.length === 0) return;
  
    // ---- Everything below remains the same, but iterate over selectedRoutes instead of dests ----
    const routesData = [];
  
    for (const sel of selectedRoutes) {
      const route = Array.isArray(sel.node_path) ? sel.node_path : [];
      const routeCoords = route
        .map(nodeId => graphData.nodes?.[nodeId])
        .filter(Boolean)
        .map(node => ({ lat: node.lat, lng: node.lng }));
      const pathLinks = Array.isArray(sel.link_ids) ? sel.link_ids : [];

      const linkById = new Map((graphData.links || []).map(r => [String(r.link_id), r]));

      // Find the last path link that touches the destination node and grab its name
      const destId = String(sel.nodeId);
      let exitLinkName = "";

      for (let i = pathLinks.length - 1; i >= 0; i--) {
        const row = linkById.get(String(pathLinks[i]));
        if (!row) continue;

        if (String(row.start_node_id) === destId || String(row.end_node_id) === destId) {
          exitLinkName = row.name || "";
          break;
        }
      }

      // Save it for checklist building
      if (exitLinkName) {
        exitLinkNameByNodeRef.current[destId] = exitLinkName;
      }
  
      // Draw true geometry per link
      const routePolylines = pathLinks.map(linkId => {
        const wkt = linkGeoms[linkId];
        if (!wkt) return null;
        const coords = wkt
          .replace(/^LINESTRING\s*\(/i, '')
          .replace(/\)$/, '')
          .split(',')
          .map(pt => {
            const [lng2, lat2] = pt.trim().split(' ').map(Number);
            return { lat: lat2, lng: lng2 };
          });
  
        return new window.google.maps.Polyline({
          path: coords,
          geodesic: true,
          strokeColor: "#186EE3",
          strokeOpacity: 0.35,
          strokeWeight: 5,
          zIndex: -1000,
          clickable: true
        });
      }).filter(Boolean);
  
      // Put on map & wire clicks
      routePolylines.forEach((poly, idx) => {
        poly.setMap(mapRef.current);
        const linkId = pathLinks[idx];
        poly.addListener("click", () => console.log(`Link ID: ${linkId}`));
        polylineRefs.current.push(poly);
      });
  
      // Destination marker
      let destinationPos = null;
      const destNode = graphData.nodes?.[String(sel.nodeId)];
      if (destNode) {
        destinationPos = { lat: destNode.lat, lng: destNode.lng };
      } else if (routeCoords.length > 0) {
        destinationPos = routeCoords[routeCoords.length - 1];
      } else if (routePolylines.length > 0) {
        const p = routePolylines[routePolylines.length - 1].getPath();
        if (p && p.getLength() > 0) {
          const last = p.getAt(p.getLength() - 1);
          destinationPos = { lat: last.lat(), lng: last.lng() };
        }
      }
      if (!destinationPos) continue;
      const destMarker = new window.google.maps.Marker({
        position: destinationPos,
        map: mapRef.current,
        icon: { url: SafetyIcon, scaledSize: new window.google.maps.Size(40, 40), anchor: new window.google.maps.Point(20, 20) },
        opacity: 1
      });
      destMarker.addListener('click', () => console.log(`Destination node ID: ${sel.nodeId}`));


      // Hospital marker
      if (!hospitalMarkerRef.current) {

        let marker = new window.google.maps.Marker({
          position: { lat: 37.715885, lng: -122.130340 },
          map: mapRef.current,
          icon: {
            url: HospitalIcon,
            scaledSize: new window.google.maps.Size(48, 48),
            anchor: new window.google.maps.Point(24, 24),
          },
          title: "Hospital",
        });

        hospitalMarkerRef.current = marker
  
      } else {
        hospitalMarkerRef.current.setMap(mapRef.current);
      }
  
      // Store for API update
      routesData.push({
        destNodeId: sel.nodeId,
        pathLinks,
        routePolylines,
        destinationPos,
        destMarker
      });
    }
  
    routesDataRef.current = routesData;
    setRouteLinkSnapshots(
      routesData.map(route => ({
        destNodeId: String(route.destNodeId ?? ""),
        pathLinks: Array.isArray(route.pathLinks) ? [...route.pathLinks] : [],
      }))
    );

    const primaryLinkIds = routesData.flatMap((route) => route.pathLinks || []);
    const connectorRoutes = buildFreeFlowConnectorRoutes({
      adjList: graphData.adjList,
      links: graphData.links,
      primaryLinkIds,
      householdNodeIds: householdNodesForDraw,
    });
    connectorRoutes.forEach((connector) => {
      const houseNode = graphData.nodes?.[connector.nodeId];
      if (houseNode) {
        const marker = new window.google.maps.Marker({
          position: { lat: houseNode.lat, lng: houseNode.lng },
          map: mapRef.current,
          icon: { url: LocationIcon, scaledSize: new window.google.maps.Size(50, 50), anchor: new window.google.maps.Point(25, 25) },
          title: `Additional household node ${connector.nodeId}`,
        });
        additionalHouseMarkersRef.current.push(marker);
      }
      connector.linkIds.forEach((linkId) => {
        const wkt = linkGeoms[linkId];
        if (!wkt) return;
        const polyline = new window.google.maps.Polyline({
          path: parseWktLineString(wkt),
          geodesic: true,
          strokeColor: "#186EE3",
          strokeOpacity: 0.9,
          strokeWeight: 5,
          zIndex: -900,
          clickable: false,
        });
        polyline.setMap(mapRef.current);
        polylineRefs.current.push(polyline);
        START_LINK_ANIM(polyline, "#186EE3", 5);
      });
    });

    const built = buildChecklistItemsAndPromptCsv({
      destinationNodes,
      graphData,
      haversineDistance,
      masterRoutesMap,
      masterRoutesEntries,
      imageVariables,
    });
    setAutoChecklistItems(built.checklistItems);
    setPromptAdditionCsv(built.promptAdditionCsv);

    // Auto-play the routes podcast once routes are drawn
    console.log("Autoplay 1", routesData, routesAudioRef, routesAudioUrl)
    if (routesData.length > 0 && routesAudioRef.current && routesAudioUrl) {
      try {
        console.log("Autoplay 2")
        if (routesAudioRef.current.paused) {
          routesAudioRef.current.currentTime = 0;
          // routesAudioRef.current.play();
        }
      } catch (err) {
        console.error("Auto-play failed:", err);
      }
    }
  
    // Fire API calls concurrently (unchanged)
    await Promise.all(routesData.map(async (routeData) => {
      const apiResponse = await getPathTimes(
        routeData.pathLinks,
        selectedTime,
        selectedSimulation.id,
        selectedSimulation.isInteractiveMap,
        apiCallControllerRef.current.signal
      );
  
      if (apiResponse && apiResponse.link_times) {
        apiResponse.link_times.forEach((linkData, idx) => {
          const poly = routeData.routePolylines[idx];
          if (!poly) return;

          const queuedCount = Number(linkData?.queued_vehicles || 0);
      
          // base color is blue; switch to orange if queued
          let color = "#186EE3";
          if (linkData?.queued_vehicles >= 1) {
            color = "#186EE3";
            poly.setOptions({ strokeColor: color });
          }

          console.log("linkData", linkData)
      
          // If queue exists, we want the free section to show orange moving dots at fft 5.
          // Otherwise use the API travel_time (your existing behavior).
          let fftSec = 5;
          if (queuedCount <= 0) {
            fftSec = Number(linkData?.travel_time) / 6 || 5;
          }

          START_LINK_ANIM(poly, "#186EE3", fftSec);
          // Fill the tail with static red dots; spacingPct can be tuned (e.g., 3–6)
          SET_LINK_QUEUE(poly, queuedCount, 4);
        });
      }
  
      if (apiResponse && typeof apiResponse.total_time !== "undefined") {
        const totalTimeSeconds = Math.round(apiResponse.total_time) + Math.round(selectedTime);
        const totalTimeStr = formatTime(totalTimeSeconds, { style: "digital" });
        const textOverlay = createTextOverlay(routeData.destinationPos, totalTimeStr);

        // If podcast is playing right now, keep this new overlay hidden
        const isPlayingNow = !!routesAudioRef.current && !routesAudioRef.current.paused;
        if (isPlayingNow) {
          textOverlay.setMap(null);
        }
        safetyCalloutsRef.current.push(textOverlay);
      }
    }));
  };

  const drawRoutesOld = async (lat, lng, selectedTime, selectedSimulation, dests) => {

    if (!dests || dests.length === 0) return; 

    // Cancel any ongoing API calls.
    if (apiCallControllerRef.current) {
      apiCallControllerRef.current.abort();
    }
    // Create a new controller for this set of API calls.
    apiCallControllerRef.current = new AbortController();

    // Draw a location marker using the LocationIcon.
    if (circleRef.current) {
      circleRef.current.setMap(null);
    }
    const locationMarker = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: {
        url: LocationIcon,
        scaledSize: new window.google.maps.Size(50, 50),
        anchor: new window.google.maps.Point(25, 25),
      },
    });
    circleRef.current = locationMarker;

    // Clear existing polylines and car markers.
    polylineRefs.current.forEach(poly => poly.setMap(null));
    polylineRefs.current = [];
    carMarkersRef.current.forEach(marker => marker.setMap(null));
    carMarkersRef.current = [];
    routesDataRef.current = [];
    setRouteLinkSnapshots([]);

    // Clear existing safety callouts.
    if (safetyCalloutsRef.current && safetyCalloutsRef.current.length > 0) {
      safetyCalloutsRef.current.forEach(callout => callout.setMap(null));
      safetyCalloutsRef.current = [];
    }

    if (!graphData.nodes || Object.keys(graphData.nodes).length === 0) return;

    console.log("Graph data:", graphData)

     // 4️⃣ build a lookup table: link_id → its raw WKT geometry
     const linkGeoms = {};
     graphData.links.forEach(row => {
       linkGeoms[row.link_id] = row.geometry;
     });
     linkGeomsRef.current = linkGeoms;

    // Find the nearest node to the click.
    let nearestNodeId = null;
    let minDist = Infinity;
    for (const node of Object.values(graphData.nodes)) {
      const d = haversineDistance(lat, lng, node.lat, node.lng);
      if (d < minDist) {
        minDist = d;
        nearestNodeId = node.id;
      }
    }
    console.log("Nearest node:", nearestNodeId);

    // Run Dijkstra from that node.
    const { distances, previous } = dijkstra(graphData.adjList, nearestNodeId);

    // Create an array to collect route data for all destinations.
    const routesData = [];

    // Process each destination.
    for (const dest of dests) {
      if (distances[dest.nodeId] < Infinity) {
        // Reconstruct the route (node IDs).
        const route = reconstructPath(previous, nearestNodeId, dest.nodeId);
        console.log(`Route to ${dest.nodeId}:`, route);

        // Convert node IDs to coordinates.
        const routeCoords = route.map(nodeId => {
          const node = graphData.nodes[nodeId];
          return { lat: node.lat, lng: node.lng };
        });

        // Build link IDs for the route.
        const pathLinks = [];
        for (let i = 0; i < route.length - 1; i++) {
          const currNodeId = route[i];
          const nextNodeId = route[i + 1];
          let linkId = null;
          if (graphData.adjList[currNodeId]) {
            const edge = graphData.adjList[currNodeId].find(e => e.node === nextNodeId);
            if (edge && edge.link) {
              linkId = edge.link.link_id; // Assumes CSV data contains "link_id"
            }
          }
          if (linkId !== null) {
            pathLinks.push(linkId);
          }
        }
        console.log("Path links for destination", dest.nodeId, ":", pathLinks);

        // Draw the route entirely in default blue.
        // c) draw each link’s true geometry, with a forward arrow at the end
        const routePolylines = pathLinks.map(linkId => {
          const wkt = linkGeoms[linkId];
          if (!wkt) return null;
          // parse "LINESTRING(lng lat, lng lat, ...)"
          const coords = wkt
            .replace(/^LINESTRING\s*\(/i, '')
            .replace(/\)$/, '')
            .split(',')
            .map(pt => {
              const [lng, lat] = pt.trim().split(' ').map(Number);
              return { lat, lng };
            });

          return new window.google.maps.Polyline({
            path: coords,
            geodesic: true,
            strokeColor: "#186EE3",
            strokeOpacity: 1,
            strokeWeight: 5,
            zIndex: -1000,
            clickable: true
          });
        })
        .filter(p => p !== null);

        // d) put them on the map & wire up clicks
        routePolylines.forEach((poly, idx) => {
          poly.setMap(mapRef.current);
          const linkId = pathLinks[idx];
          poly.addListener("click", () => console.log(`Link ID: ${linkId}`));
          polylineRefs.current.push(poly);
        });


        // Place a safety marker at the destination.
        const destinationPos = routeCoords[routeCoords.length - 1];
        const destMarker = new window.google.maps.Marker({
          position: destinationPos,
          map: mapRef.current,
          icon: {
            url: SafetyIcon,
            scaledSize: new window.google.maps.Size(40, 40),
            anchor: new window.google.maps.Point(20, 20),
          },
          opacity: 1
        });

        // log the nodeId when the flag is clicked
          destMarker.addListener('click', () => {
            console.log(`Destination node ID: ${dest.nodeId}`);
          });

        // Store this route for later API update.
        routesData.push({
          destNodeId: dest.nodeId,
          pathLinks,  
          routePolylines,
          destinationPos,
          destMarker
        });
      }
    } // end for each destination

    routesDataRef.current = routesData;
    setRouteLinkSnapshots(
      routesData.map(route => ({
        destNodeId: String(route.destNodeId ?? ""),
        pathLinks: Array.isArray(route.pathLinks) ? [...route.pathLinks] : [],
      }))
    );

    // Fire off all API calls concurrently.
    await Promise.all(routesData.map(async (routeData) => {
      // Pass the abort signal from our controller.
      const apiResponse = await getPathTimes(routeData.pathLinks, selectedTime, selectedSimulation.id, selectedSimulation.isInteractiveMap, apiCallControllerRef.current.signal);
      // Update polyline colors based on traffic congestion.
      if (apiResponse && apiResponse.link_times) {
        apiResponse.link_times.forEach((linkData, idx) => {
          if (linkData.queued_vehicles >= 1 && routeData.routePolylines[idx]) {
            routeData.routePolylines[idx].setOptions({ 
              strokeColor: "#FFA000",
             });
          }
        });
      }
      // Create a text overlay for total travel time.
      if (apiResponse && typeof apiResponse.total_time !== "undefined") {
        const totalTimeSeconds = Math.round(apiResponse.total_time) + Math.round(selectedTime);
        console.log("Calculating total time", "selectedTime:", selectedTime, "API response time:", apiResponse.total_time, "Total time:", totalTimeSeconds)
        const totalTimeStr = formatTime(totalTimeSeconds, { style: "digital" });
        const textOverlay = createTextOverlay(routeData.destinationPos, totalTimeStr);
        safetyCalloutsRef.current.push(textOverlay);
      }
    }));
  }

  const handleMapClick = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    if (isSelectingPolygon) {
      setDraftPolygonPoints((prev) => [...prev, { lat, lng }]);
      return;
    }

    if (isPickingDefaultLocation) {
      setDefaultLocationDraft({ lat, lng });
      setDefaultLocationStatus("Location selected. Click \"Save\" to keep it.");
      setDefaultLocationError("");
      if (mapRef.current) {
        modifyMapCamera(mapRef.current, { lat, lng }, activeDefaultZoomDraft, 300);
      }
      return;
    }

    if (isPickingAdditionalHousehold) {
      let closestNodeId = "";
      let closestDistance = Infinity;
      Object.values(graphData?.nodes || {}).forEach((node) => {
        const distance = haversineDistance(lat, lng, node.lat, node.lng);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestNodeId = String(node.id);
        }
      });
      setIsPickingAdditionalHousehold(false);
      if (!closestNodeId) {
        setAdditionalNodesStatus("No graph node was found near that point.");
        return;
      }
      setAdditionalNodesStatus(`Selected node ${closestNodeId}. Saving…`);
      await addAdditionalHouseholdNodeById(closestNodeId);
      return;
    }

    if (routeEditSession?.isActive) {
      const nearest = findNearestLinkToPoint({ lat, lng });
      if (!nearest?.link_id) return;
      const linkId = String(nearest.link_id);
      setRouteEditSession((prev) => {
        if (!prev?.isActive) return prev;
        const existingIdx = (prev.draftLinks || []).findIndex((l) => String(l?.id) === linkId);
        if (existingIdx >= 0) {
          const next = [...(prev.draftLinks || [])];
          next.splice(existingIdx, 1);
          return { ...prev, draftLinks: next };
        }
        const nextLink = toRouteEditDraftLink(linkId);
        if (!nextLink) return prev;
        return { ...prev, draftLinks: [...(prev.draftLinks || []), nextLink] };
      });
      return;
    }

    setSelectedLocation({lat: lat, lng: lng})

    console.log("Map clicked at:", { lat, lng, time, selectedSimulation });

    cancelRouteEdit();
    setFocusedMasterRouteNodeId(null);
    wantRoutesAutoplayRef.current = false;
    drawRoutes(lat, lng, time, selectedSimulation, destinationNodes)
    
  };



  const handleTimeChange = (e) => { 
    const newT = Number(e.target.value);
    setTime(newT);
    if (selectedLocation && selectedSimulation) {
      drawRoutes(selectedLocation.lat, selectedLocation.lng, newT, selectedSimulation, destinationNodes);
    }

  };

  const togglePolylines = () => { setShowPolyLines(!showPolyLines); };

  const handleSimulationChange = (sim) => {
    if (!sim) return;
    setSelectedSimulation(sim);
    initialSimulationAppliedRef.current = true;
    cancelRouteEdit();
    setFocusedMasterRouteNodeId(null);
    if (selectedLocation) {
      drawRoutes(selectedLocation.lat, selectedLocation.lng, time, sim, destinationNodes);
    }
  };

  const loadFireOverlay = () => {
    // Add the fire marker here:
    // Define the fixed center and the offset in meters
    const fireCenter = { lat: 37.891993946041026, lng: -122.24859240728762 };
    const meters = 400; // adjust this value: approximately 150 meters covers 3 blocks
    const meterToDegLat = 1 / 111000; // roughly 1° latitude = 111 km
    // For longitude, adjust by the cosine of the latitude.
    const meterToDegLng = 1 / (111000 * Math.cos(fireCenter.lat * Math.PI / 180));
    const latOffset = meters * meterToDegLat;
    const lngOffset = meters * meterToDegLng;

    // Create bounds for the GroundOverlay.
    const bounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(fireCenter.lat - latOffset, fireCenter.lng - lngOffset),
      new window.google.maps.LatLng(fireCenter.lat + latOffset, fireCenter.lng + lngOffset)
    );

    // Create and display the GroundOverlay using your FireImage.
    new window.google.maps.GroundOverlay(FireImage, bounds, { opacity: 0.75 }).setMap(mapRef.current);
  }

  

  const audioSegments = React.useMemo(() => {
    const sorted = Object.entries(activeRoutesAudioTimings)
      .map(([title, start]) => ({ title, start }))
      .sort((a, b) => a.start - b.start);
    sorted.forEach((seg, i) => seg.end = i < sorted.length - 1 ? sorted[i + 1].start : Infinity);
    return sorted;
  }, [activeRoutesAudioTimings]);
  
  const nodeIdForTime = (t) => {
    const seg = audioSegments.find(s => t >= s.start && t < s.end);
    if (!seg) return null;
    const item = activeChecklistItems.find(i => i.title === seg.title);
    return item?.nodeId ?? null;
  };

  const updateRouteOpacity = (activeNodeId) => {
    routesDataRef.current.forEach(r => {
      const isActive = activeNodeId && String(r.destNodeId) === String(activeNodeId);
  
      // Polylines: when a destination is active, only keep its route visible.
      r.routePolylines.forEach(p => {
        if (activeNodeId && !isActive) {
          p.setMap(null);
        } else {
          p.setOptions({ strokeOpacity: 1 });
          if (p.getMap() === null) p.setMap(mapRef.current);
        }
        SET_LINK_ANIM_VISIBLE(p, !!(isActive || !activeNodeId));
      });
  
      // Destination markers: only active destination in focused mode.
      if (activeNodeId) {
        if (isActive) {
          if (!r.destMarker.getMap()) r.destMarker.setMap(mapRef.current);
          r.destMarker.setOpacity(1);
        } else {
          r.destMarker.setMap(null);
        }
      } else {
        // No active node: show all again
        if (!r.destMarker.getMap()) r.destMarker.setMap(mapRef.current);
        r.destMarker.setOpacity(1);
      }
    });
  };

  useEffect(() => {
    const activeNodeId = routeEditSession?.isActive
      ? routeEditSession.nodeId
      : focusedMasterRouteNodeId;
    updateRouteOpacity(activeNodeId || null);
  }, [focusedMasterRouteNodeId, routeEditSession?.isActive, routeEditSession?.nodeId, routeLinkSnapshots]);

  const handleLocationSearch = async () => {
    const query = searchText.trim();
    if (!query) return;
  
    try {
      setIsSearchingLoc(true);
      const { lat, lng } = await geocodeAddress(query, "", "");      // already imported
      const latNum = +lat, lngNum = +lng;
  
      setSelectedLocation({ lat: latNum, lng: lngNum });
  
      if (mapRef.current) {
        modifyMapCamera(
          mapRef.current,
          { lat: latNum, lng: lngNum }, // target centre
          14.5,                           // target zoom
          1000                          // duration (ms)
        );
      }
      if (selectedSimulation){
        cancelRouteEdit();
        setFocusedMasterRouteNodeId(null);
        wantRoutesAutoplayRef.current = false;
        drawRoutes(latNum, lngNum, time, selectedSimulation, destinationNodes);
      }
    } catch (err) {
      console.error("Geocode failed:", err);
    } finally {
      setIsSearchingLoc(false);
    }
  };

  const modifyMapCamera = (map, endCenter, endZoom, duration = 1000) => {
    const startCenter = map.getCenter().toJSON();
    const startZoom   = map.getZoom();
    const frames      = Math.round((duration / 1000) * 60); // ~60 fps
    let frame = 0;
  
    const latDiff  = endCenter.lat - startCenter.lat;
    const lngDiff  = endCenter.lng - startCenter.lng;
    const zoomDiff = endZoom       - startZoom;
  
    const step = () => {
      frame += 1;
      const t    = frame / frames;
      const ease = t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;   // ease-in/out
  
      map.setCenter({
        lat: startCenter.lat + latDiff * ease,
        lng: startCenter.lng + lngDiff * ease
      });
      map.setZoom(startZoom + zoomDiff * ease);
  
      if (frame < frames) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };


  return (
    <div style={{ display: "flex", flexDirection: "row", padding: "20px", color: "#000" }}>
      {/* Left Pane */}
      <div style={{ flex: "0 0 48%", marginRight: "20px" }}>
        <h1>{podcastId}</h1>


        <div style={{ width: "100%", display: "flex", alignItems: "center", gap: 16, marginBottom: '20px' }}>
          <strong>Language:</strong>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={selectedLanguage === 'EN'}
              onChange={() => setSelectedLanguage('EN')}
            />
            English
          </label>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={selectedLanguage === 'ES'}
              onChange={() => setSelectedLanguage('ES')}
            />
            Spanish
          </label>
        </div>

        {!isMobile && (
          <SearchBar
            value={searchText}
            onChange={setSearchText}
            onSubmit={handleLocationSearch}
            isLoading={isSearchingLoc}
            containerStyle={{ marginBottom: 12, marginTop: 30 }}
          />
        )}

        {!isMobile && (
          <div style={{ display: "flex", gap: 8, marginTop: 8, marginBottom: 12 }}>
            <input
              type="number"
              inputMode="numeric"
              placeholder="NodeId (optional)"
              value={nodeIdText}
              onChange={(e) => setNodeIdText(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") handleNodeIdSubmit(); }}
              style={{
                flex: 1,
                padding: "8px 10px",
                border: "1px solid #ccc",
                borderRadius: 6
              }}
            />
            <button
              onClick={handleNodeIdSubmit}
              style={{
                padding: "8px 12px",
                border: "none",
                borderRadius: 6,
                background: "#0b5fff",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
                whiteSpace: "nowrap"
              }}
              title="Route from this node"
            >
              Go
            </button>
          </div>
        )}

        <div role="tablist" aria-label="Editor tabs" className="editor-tabs">
          <button
            role="tab"
            className="editor-tab"
            aria-selected={editTab === "general-details"}
            aria-controls="panel-general"
            id="tab-general"
            tabIndex={editTab === "general-details" ? 0 : -1}
            onClick={() => setEditTab("general-details")}
          >
            general details
          </button>

          <button
            role="tab"
            className="editor-tab"
            aria-selected={editTab === "next-steps-faq"}
            aria-controls="panel-next-steps-faq"
            id="tab-next-steps-faq"
            tabIndex={editTab === "next-steps-faq" ? 0 : -1}
            onClick={() => setEditTab("next-steps-faq")}
          >
            next steps
          </button>
            
            
            <button
              role="tab"
              className="editor-tab"
              aria-selected={editTab === "pre-audio"}
              aria-controls="panel-pre"
              id="tab-pre"
              tabIndex={editTab === "pre-audio" ? 0 : -1}
              onClick={() => setEditTab("pre-audio")}
            >
              pre-audio
            </button>

            <button
              role="tab"
              className="editor-tab"
              aria-selected={editTab === "audio"}
              aria-controls="panel-audio"
              id="tab-audio"
              tabIndex={editTab === "audio" ? 0 : -1}
              onClick={() => setEditTab("audio")}
            >
              audio
            </button>

            <button
              role="tab"
              className="editor-tab"
              aria-selected={editTab === "post-audio"}
              aria-controls="panel-post"
              id="tab-post"
              tabIndex={editTab === "post-audio" ? 0 : -1}
              onClick={() => setEditTab("post-audio")}
            >
              post-audio
            </button>
        </div>


        {editTab === "general-details" && (
          <div style={{ marginTop: "20px" }} id="panel-general" role="tabpanel" aria-labelledby="tab-general">
            <div style={{ padding: "20px", border: "1px solid #ccc" }}>
              <GeneralDetailsTab
                isActive={true}
                podcastId={podcastId}
                selectedLanguage={selectedLanguage}
                polygonDraftPoints={draftPolygonPoints}
                isSelectingPolygon={isSelectingPolygon}
                onStartPolygon={startPolygonSelection}
                onCancelPolygon={cancelPolygonSelection}
                onUndoPolygonPoint={undoPolygonPoint}
                onPolygonSaved={handlePolygonSaved}
                onPreviewPolygon={handlePreviewPolygon}
                onClearPreviewPolygon={clearPreviewPolygon}
                currentPreviewPolygonKey={previewPolygon?.key || ""}
                defaultLocation={defaultLocation}
                defaultLocationDraft={defaultLocationDraft}
                defaultZoom={defaultZoom}
                defaultZoomDraft={defaultZoomDraft}
                onDefaultZoomDraftChange={handleDefaultZoomDraftChange}
                onSaveDefaultLocation={handleSaveDefaultLocation}
                isSavingDefaultLocation={isSavingDefaultLocation}
                defaultLocationStatus={defaultLocationStatus}
                defaultLocationError={defaultLocationError}
                defaultLocationLoading={isLoadingDefaultLocation}
                isPickingDefaultLocation={isPickingDefaultLocation}
                onStartDefaultLocationPick={beginDefaultLocationPick}
                onCancelDefaultLocationPick={cancelDefaultLocationPick}
                simulations={simulations}
                defaultSimulationId={defaultSimulationId}
                defaultSimulationDraft={defaultSimulationDraft}
                onDefaultSimulationSelect={handleDefaultSimulationSelect}
                isSavingDefaultSimulation={isSavingDefaultSimulation}
                defaultSimulationStatus={defaultSimulationStatus}
                defaultSimulationError={defaultSimulationError}
                oneCarSimulationId={oneCarSimulationId}
                oneCarSimulationDraft={oneCarSimulationDraft}
                onOneCarSimulationSelect={handleOneCarSimulationSelect}
                isSavingOneCarSimulation={isSavingOneCarSimulation}
                oneCarSimulationStatus={oneCarSimulationStatus}
                oneCarSimulationError={oneCarSimulationError}
                onImageVariablesChange={setImageVariables}
              />
            </div>
          </div>
        )}

        {editTab === "next-steps-faq" && (
          <div style={{ marginTop: "20px" }} id="panel-next-steps-faq" role="tabpanel" aria-labelledby="tab-next-steps-faq">
            <div style={{ padding: "20px", border: "1px solid #ccc" }}>
              <NextStepsFaqTab
                isActive={true}
                podcastId={podcastId}
                selectedLanguage={selectedLanguage}
              />
            </div>
          </div>
        )}

        
        {selectedLocation && editTab !== "general-details" && editTab !== "next-steps-faq" && (
          <div style={{ marginTop: "20px" }}>
          <div style={{ padding: "20px", border: "1px solid #ccc" }}>


            {editTab === "pre-audio" && (
              <div>
            
                {/* ❷ Checklist (same hover‑play style you used before) */}
                <style>{`
                  .route-check-item {
                    width: 350px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    padding: 5px;
                    position: relative;
                  }
                  .route-check-item .play-button { display: none; }
                  .route-check-item:hover .play-button { display: block; }
                `}</style>


                <div style={{ fontWeight: 600, marginBottom: 6 }}>
                  NodeId: {String(nearestNodeId || "") || "—"}
                </div>
                <div style={{ marginBottom: 16, padding: 12, border: "1px solid #d7dce3", borderRadius: 8 }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>Additional households</div>
                  <div style={{ fontSize: 13, color: "#555", marginBottom: 8 }}>
                    Add graph nodes whose free-flow routes should merge into this location’s primary routes.
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <input
                      type="number"
                      inputMode="numeric"
                      placeholder="Node ID"
                      value={additionalNodeIdText}
                      onChange={(event) => setAdditionalNodeIdText(event.target.value)}
                      onKeyDown={(event) => { if (event.key === "Enter") addAdditionalHouseholdNode(); }}
                      style={{ flex: 1, padding: "7px 9px", border: "1px solid #bbb", borderRadius: 6 }}
                    />
                    <button type="button" onClick={addAdditionalHouseholdNode}>Add house</button>
                    <button
                      type="button"
                      onClick={() => {
                        cancelRouteEdit();
                        setIsPickingAdditionalHousehold((active) => !active);
                        setAdditionalNodesStatus("Click the map near the household location.");
                      }}
                      disabled={!nearestNodeId}
                      style={{ background: isPickingAdditionalHousehold ? "#0b5fff" : undefined, color: isPickingAdditionalHousehold ? "#fff" : undefined }}
                    >
                      {isPickingAdditionalHousehold ? "Cancel map pick" : "Add by map"}
                    </button>
                  </div>
                  {additionalHouseholdNodes.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 10 }}>
                      {additionalHouseholdNodes.map((nodeId) => (
                        <span key={nodeId} style={{ display: "inline-flex", gap: 6, alignItems: "center", padding: "4px 7px", background: "#eef3f8", borderRadius: 999 }}>
                          Node {nodeId}
                          <button
                            type="button"
                            aria-label={`Remove household node ${nodeId}`}
                            onClick={() => saveAdditionalHouseholdNodes(additionalHouseholdNodes.filter((id) => id !== nodeId))}
                            style={{ border: 0, background: "transparent", cursor: "pointer", padding: 0 }}
                          >×</button>
                        </span>
                      ))}
                    </div>
                  )}
                  {additionalNodesStatus && <div style={{ fontSize: 12, marginTop: 6 }}>{additionalNodesStatus}</div>}
                </div>
                <MasterRoutesPanel
                  podcastId={podcastId}
                  nodeId={nearestNodeId}
                  autoChecklistItems={autoChecklistItems}
                  routeLinkSnapshots={routeLinkSnapshots}
                  graphData={graphData}
                  onMasterRoutesChange={handleMasterRoutesChange}
                  onMasterRoutesSaved={handleMasterRoutesSaved}
                  onActiveDestinationChange={setFocusedMasterRouteNodeId}
                  routeEditState={routeEditSession}
                  onStartRouteEdit={startRouteEditForDestination}
                  onCancelRouteEdit={cancelRouteEdit}
                  onSaveRouteEdit={saveRouteEdit}
                  onRemoveRouteEditLink={removeRouteEditLink}
                  onFlipRouteEditLink={flipRouteEditLink}
                />

                <TravelNarrativeRouteTablesPanel
                    podcastId={podcastId}
                    nodeId={nearestNodeId}
                    selectedLanguage={selectedLanguage}
                    canGenerate={!!selectedLocation}
                    onGenerate={handleGetTravelExperience}
                    onRegenerateRouteTables={handleGetTravelExperience}
                    isGenerating={isGeneratingTravelNarrative}
                    travelExpNarrativeStream={travelExpNarrativeStream}
                    setTravelExpNarrativeStream={setTravelExpNarrativeStream}
                    routeTablesDraft={routeTablesDraft}
                    setRouteTablesDraft={setRouteTablesDraft}
                    autoChecklistItems={autoChecklistItems}
                    setAutoChecklistItems={setAutoChecklistItems}
                    promptAdditionCsv={promptAdditionCsv}
                    setPromptAdditionCsv={setPromptAdditionCsv}
                  />

                
              </div>
            )}

            {editTab === "audio" && (
              <div id="panel-audio" role="tabpanel" aria-labelledby="tab-audio">
                <AudioReviewTab
                  isActive={true}
                  podcastId={podcastId}
                  nodeId={editingNodeId}
                  selectedLanguage={selectedLanguage}
                />
              </div>
            )}

            <PostAudioTab
              isActive={editTab === "post-audio"}
              podcastId={podcastId}
              nodeId={editingNodeId}
              selectedLanguage={selectedLanguage}
            />


          </div>
        </div>
        )}
      </div>
      
      {/* Right Pane */}
      <div style={{ flex: "0 0 50%" }}>
        <div style={{ marginBottom: "20px", position: "relative" }}>
          {/* Simulation Dropdown & Time Slider */}
          <div style={{ marginRight: "20px", minWidth: 240 }}>
            <SimulationSelector
              simulations={simulations}
              selectedId={selectedSimulation?.id}
              onSelect={handleSimulationChange}
              variant="light"
            />
          </div>
          <div style={{ paddingTop: "20px", marginBottom: "10px" }}>
            <input
              type="range"
              min="0"
              max={selectedSimulation?.total_time || 0}
              step="30"
              value={time}
              onChange={handleTimeChange}
              style={{
                width: "100%",
                marginBottom: "10px",
                backgroundColor: "#3A3A3A"
              }}
            />
            <div style={{ textAlign: "center" }}>Delayed by {formatTime(time)}</div>
          </div>


          <div style={{ position: "relative", marginTop: 10 /* NEW wrapper */ }}>
            <div
              style={{
                position: "absolute",
                top: 10, left: 0, right: 0,
                width: "90%", maxWidth: 500, margin: "0 auto",
                zIndex: 5
              }}
            >
              {!isPodcastPlaying && isMobile && (
                <SearchBar
                  value={searchText}
                  onChange={setSearchText}
                  onSubmit={handleLocationSearch}
                  isLoading={isSearchingLoc}
                />
              )}

              {isPodcastPlaying && activeCallout && (
                  <div
                  style={{
                    background: activeCallout.bg || "#fff",
                    color: activeCallout.textColor || "#111",
                    borderRadius: 14,
                    padding: "12px 16px",
                    boxShadow: "0 8px 24px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.12)",
                    fontSize: 18,         
                    lineHeight: 1.4,
                    fontFamily:
                      '"Segoe Print","Comic Sans MS","Bradley Hand","Apple Chancery","Caveat","Patrick Hand",cursive',
                    whiteSpace: "pre-line"
                  }}
                >
                  {activeCallout.text}
                </div>
                )}
            </div>

            <BalloonsOverlay
              show={!!balloonsSpec}
              count={balloonsSpec?.count ?? 15}
              emoji={balloonsSpec?.emoji ?? "🎈"}
              minDuration={balloonsSpec?.minDuration ?? 3.0}
              maxDuration={balloonsSpec?.maxDuration ?? 4.2}
              topBeyondVh={balloonsSpec?.topBeyondVh ?? 180}
            />

            <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
            
            {isPickingDefaultLocation && (
              <div
                style={{
                  position: "absolute",
                  top: 18,
                  left: 18,
                  zIndex: 20,
                  background: "#111827",
                  color: "#fff",
                  padding: "8px 14px",
                  borderRadius: 999,
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  boxShadow: "0 10px 20px rgba(0,0,0,0.35)"
                }}
              >
                <span style={{ fontWeight: 600 }}>Editing location</span>
                <button
                  onClick={cancelDefaultLocationPick}
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "#fff",
                    fontSize: 16,
                    cursor: "pointer",
                    lineHeight: 1
                  }}
                  aria-label="Cancel editing location"
                >
                  ×
                </button>
              </div>
            )}
            {isPickingAdditionalHousehold && (
              <div
                style={{
                  position: "absolute",
                  top: 18,
                  left: 18,
                  zIndex: 20,
                  background: "#14532d",
                  color: "#fff",
                  padding: "8px 14px",
                  borderRadius: 999,
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  boxShadow: "0 10px 20px rgba(0,0,0,0.35)"
                }}
              >
                <span style={{ fontWeight: 600 }}>Click near the additional household</span>
                <button
                  type="button"
                  onClick={() => setIsPickingAdditionalHousehold(false)}
                  aria-label="Cancel adding household by map"
                  style={{ border: 0, background: "transparent", color: "#fff", fontSize: 16, cursor: "pointer", padding: 0 }}
                >×</button>
              </div>
            )}
            
            <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={mapCenter}
                zoom={activeDefaultZoomDraft}
                onLoad={(map) => {
                  mapRef.current = map;
                  setMapReady(true);
                }}
                onClick={handleMapClick}
                options={{
                  styles: darkMapStyle,
                  draggableCursor: isPickingAdditionalHousehold ? "crosshair" : undefined,
                  disableDefaultUI: true,
                  mapTypeControl: false,
                  zoomControl: false,
                  streetViewControl: false,
                  fullscreenControl: false,
                  scaleControl: false,
                  rotateControl: false,
                  keyboardShortcuts: false
                }}
              >
                {draftPolygonPoints.length > 0 && (
                  <Polygon
                    path={draftPolygonPoints}
                    options={{
                      fillColor: "#F97316",
                      fillOpacity: 0.2,
                      strokeColor: "#F97316",
                      strokeOpacity: 0.9,
                      strokeWeight: 2,
                      clickable: false,
                      zIndex: 9999
                    }}
                  />
                )}
                {previewPolygon?.path?.length >= 3 && (
                  <Polygon
                    path={previewPolygon.path}
                    options={{
                      fillColor: "#2563EB",
                      fillOpacity: 0.1,
                      strokeColor: "#2563EB",
                      strokeOpacity: 0.8,
                      strokeWeight: 3,
                      clickable: false,
                      zIndex: 9998
                    }}
                  />
                )}
                {isPickingDefaultLocation && defaultLocationDraft && (
                  <Marker
                    position={defaultLocationDraft}
                    icon={defaultLocationMarkerIcon || undefined}
                    zIndex={9999}
                  />
                )}
                {/* Render additional overlays, e.g., car markers via state */}
                {carOverlays}
              </GoogleMap>
            </LoadScript>
            </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveMapEdit;
